module.exports = [
	{
		"aliases": [
			"grinning"
		],
		"filename": "1f600",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smiley"
		],
		"filename": "1f603",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smile"
		],
		"filename": "1f604",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"grin"
		],
		"filename": "1f601",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"laughing",
			"satisfied"
		],
		"filename": "1f606",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sweat_smile"
		],
		"filename": "1f605",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"rofl"
		],
		"filename": "1f923",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"joy"
		],
		"filename": "1f602",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"slightly_smiling_face"
		],
		"filename": "1f642",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"upside_down_face"
		],
		"filename": "1f643",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"wink"
		],
		"filename": "1f609",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"blush"
		],
		"filename": "1f60a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"innocent"
		],
		"filename": "1f607",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smiling_face_with_three_hearts"
		],
		"filename": "1f970",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"heart_eyes"
		],
		"filename": "1f60d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"star_struck"
		],
		"filename": "1f929",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_heart"
		],
		"filename": "1f618",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing"
		],
		"filename": "1f617",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"relaxed"
		],
		"filename": "263a-fe0f",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_closed_eyes"
		],
		"filename": "1f61a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"kissing_smiling_eyes"
		],
		"filename": "1f619",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"yum"
		],
		"filename": "1f60b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue"
		],
		"filename": "1f61b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue_winking_eye"
		],
		"filename": "1f61c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"zany_face"
		],
		"filename": "1f92a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"stuck_out_tongue_closed_eyes"
		],
		"filename": "1f61d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"money_mouth_face"
		],
		"filename": "1f911",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"hugs"
		],
		"filename": "1f917",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_over_mouth"
		],
		"filename": "1f92d",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"shushing_face"
		],
		"filename": "1f92b",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"thinking"
		],
		"filename": "1f914",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"zipper_mouth_face"
		],
		"filename": "1f910",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_eyebrow"
		],
		"filename": "1f928",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"neutral_face"
		],
		"filename": "1f610",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"expressionless"
		],
		"filename": "1f611",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"no_mouth"
		],
		"filename": "1f636",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"smirk"
		],
		"filename": "1f60f",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"unamused"
		],
		"filename": "1f612",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"roll_eyes"
		],
		"filename": "1f644",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"grimacing"
		],
		"filename": "1f62c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"lying_face"
		],
		"filename": "1f925",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"relieved"
		],
		"filename": "1f60c",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"pensive"
		],
		"filename": "1f614",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sleepy"
		],
		"filename": "1f62a",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"drooling_face"
		],
		"filename": "1f924",
		"category": "smileys_emotion",
		"batch": "1"
	},
	{
		"aliases": [
			"sleeping"
		],
		"filename": "1f634",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"mask"
		],
		"filename": "1f637",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"face_with_thermometer"
		],
		"filename": "1f912",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"face_with_head_bandage"
		],
		"filename": "1f915",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"nauseated_face"
		],
		"filename": "1f922",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"vomiting_face"
		],
		"filename": "1f92e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sneezing_face"
		],
		"filename": "1f927",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"hot_face"
		],
		"filename": "1f975",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cold_face"
		],
		"filename": "1f976",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"woozy_face"
		],
		"filename": "1f974",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"dizzy_face"
		],
		"filename": "1f635",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"exploding_head"
		],
		"filename": "1f92f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cowboy_hat_face"
		],
		"filename": "1f920",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"partying_face"
		],
		"filename": "1f973",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sunglasses"
		],
		"filename": "1f60e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"nerd_face"
		],
		"filename": "1f913",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"monocle_face"
		],
		"filename": "1f9d0",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"confused"
		],
		"filename": "1f615",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"worried"
		],
		"filename": "1f61f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"slightly_frowning_face"
		],
		"filename": "1f641",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_face"
		],
		"filename": "2639-fe0f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"open_mouth"
		],
		"filename": "1f62e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"hushed"
		],
		"filename": "1f62f",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"astonished"
		],
		"filename": "1f632",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"flushed"
		],
		"filename": "1f633",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"pleading_face"
		],
		"filename": "1f97a",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning"
		],
		"filename": "1f626",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"anguished"
		],
		"filename": "1f627",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"fearful"
		],
		"filename": "1f628",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cold_sweat"
		],
		"filename": "1f630",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"disappointed_relieved"
		],
		"filename": "1f625",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cry"
		],
		"filename": "1f622",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sob"
		],
		"filename": "1f62d",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"scream"
		],
		"filename": "1f631",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"confounded"
		],
		"filename": "1f616",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"persevere"
		],
		"filename": "1f623",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"disappointed"
		],
		"filename": "1f61e",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"sweat"
		],
		"filename": "1f613",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"weary"
		],
		"filename": "1f629",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"tired_face"
		],
		"filename": "1f62b",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"yawning_face"
		],
		"filename": "1f971",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"triumph"
		],
		"filename": "1f624",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"rage",
			"pout"
		],
		"filename": "1f621",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"angry"
		],
		"filename": "1f620",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"cursing_face"
		],
		"filename": "1f92c",
		"category": "smileys_emotion",
		"batch": "2"
	},
	{
		"aliases": [
			"smiling_imp"
		],
		"filename": "1f608",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"imp"
		],
		"filename": "1f47f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"skull"
		],
		"filename": "1f480",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"skull_and_crossbones"
		],
		"filename": "2620-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"hankey",
			"poop",
			"shit"
		],
		"filename": "1f4a9",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"clown_face"
		],
		"filename": "1f921",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"japanese_ogre"
		],
		"filename": "1f479",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"japanese_goblin"
		],
		"filename": "1f47a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"ghost"
		],
		"filename": "1f47b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"alien"
		],
		"filename": "1f47d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"space_invader"
		],
		"filename": "1f47e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"robot"
		],
		"filename": "1f916",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smiley_cat"
		],
		"filename": "1f63a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smile_cat"
		],
		"filename": "1f638",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"joy_cat"
		],
		"filename": "1f639",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart_eyes_cat"
		],
		"filename": "1f63b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"smirk_cat"
		],
		"filename": "1f63c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"kissing_cat"
		],
		"filename": "1f63d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"scream_cat"
		],
		"filename": "1f640",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"crying_cat_face"
		],
		"filename": "1f63f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"pouting_cat"
		],
		"filename": "1f63e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"see_no_evil"
		],
		"filename": "1f648",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"hear_no_evil"
		],
		"filename": "1f649",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"speak_no_evil"
		],
		"filename": "1f64a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"kiss"
		],
		"filename": "1f48b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"love_letter"
		],
		"filename": "1f48c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"cupid"
		],
		"filename": "1f498",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"gift_heart"
		],
		"filename": "1f49d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"sparkling_heart"
		],
		"filename": "1f496",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heartpulse"
		],
		"filename": "1f497",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heartbeat"
		],
		"filename": "1f493",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"revolving_hearts"
		],
		"filename": "1f49e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"two_hearts"
		],
		"filename": "1f495",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart_decoration"
		],
		"filename": "1f49f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_heart_exclamation"
		],
		"filename": "2763-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"broken_heart"
		],
		"filename": "1f494",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"heart"
		],
		"filename": "2764-fe0f",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"orange_heart"
		],
		"filename": "1f9e1",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"yellow_heart"
		],
		"filename": "1f49b",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"green_heart"
		],
		"filename": "1f49a",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"blue_heart"
		],
		"filename": "1f499",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"purple_heart"
		],
		"filename": "1f49c",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"brown_heart"
		],
		"filename": "1f90e",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"black_heart"
		],
		"filename": "1f5a4",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"white_heart"
		],
		"filename": "1f90d",
		"category": "smileys_emotion",
		"batch": "3"
	},
	{
		"aliases": [
			"100"
		],
		"filename": "1f4af",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"anger"
		],
		"filename": "1f4a2",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"boom",
			"collision"
		],
		"filename": "1f4a5",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"dizzy"
		],
		"filename": "1f4ab",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"sweat_drops"
		],
		"filename": "1f4a6",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"dash"
		],
		"filename": "1f4a8",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"hole"
		],
		"filename": "1f573-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"bomb"
		],
		"filename": "1f4a3",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"speech_balloon"
		],
		"filename": "1f4ac",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"eye_speech_bubble"
		],
		"filename": "1f441-fe0f-200d-1f5e8-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"left_speech_bubble"
		],
		"filename": "1f5e8-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"right_anger_bubble"
		],
		"filename": "1f5ef-fe0f",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"thought_balloon"
		],
		"filename": "1f4ad",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"zzz"
		],
		"filename": "1f4a4",
		"category": "smileys_emotion",
		"batch": "4"
	},
	{
		"aliases": [
			"wave"
		],
		"filename": "1f44b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand"
		],
		"filename": "1f91a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed"
		],
		"filename": "1f590",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"hand",
			"raised_hand"
		],
		"filename": "270b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute"
		],
		"filename": "1f596",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand"
		],
		"filename": "1f44c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_hand"
		],
		"filename": "1f90f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"v"
		],
		"filename": "270c-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers"
		],
		"filename": "1f91e",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture"
		],
		"filename": "1f91f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"metal"
		],
		"filename": "1f918",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"call_me_hand"
		],
		"filename": "1f919",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_left"
		],
		"filename": "1f448",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_right"
		],
		"filename": "1f449",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_up_2"
		],
		"filename": "1f446",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"middle_finger",
			"fu"
		],
		"filename": "1f595",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_down"
		],
		"filename": "1f447",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"point_up"
		],
		"filename": "261d-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"+1",
			"thumbsup"
		],
		"filename": "1f44d",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"-1",
			"thumbsdown"
		],
		"filename": "1f44e",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_raised",
			"fist"
		],
		"filename": "270a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_oncoming",
			"facepunch",
			"punch"
		],
		"filename": "1f44a",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_left"
		],
		"filename": "1f91b",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"fist_right"
		],
		"filename": "1f91c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"clap"
		],
		"filename": "1f44f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hands"
		],
		"filename": "1f64c",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"open_hands"
		],
		"filename": "1f450",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"palms_up_together"
		],
		"filename": "1f932",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"handshake"
		],
		"filename": "1f91d",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"pray"
		],
		"filename": "1f64f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"writing_hand"
		],
		"filename": "270d-fe0f",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"nail_care"
		],
		"filename": "1f485",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"selfie"
		],
		"filename": "1f933",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"muscle"
		],
		"filename": "1f4aa",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"mechanical_arm"
		],
		"filename": "1f9be",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"mechanical_leg"
		],
		"filename": "1f9bf",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"leg"
		],
		"filename": "1f9b5",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"foot"
		],
		"filename": "1f9b6",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ear"
		],
		"filename": "1f442",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid"
		],
		"filename": "1f9bb",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"nose"
		],
		"filename": "1f443",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"brain"
		],
		"filename": "1f9e0",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"tooth"
		],
		"filename": "1f9b7",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"bone"
		],
		"filename": "1f9b4",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"eyes"
		],
		"filename": "1f440",
		"category": "people_body",
		"batch": "1"
	},
	{
		"aliases": [
			"eye"
		],
		"filename": "1f441",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tongue"
		],
		"filename": "1f445",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"lips"
		],
		"filename": "1f444",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"baby"
		],
		"filename": "1f476",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"child"
		],
		"filename": "1f9d2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"boy"
		],
		"filename": "1f466",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"girl"
		],
		"filename": "1f467",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"adult"
		],
		"filename": "1f9d1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_person",
			"person_with_blond_hair"
		],
		"filename": "1f471",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"man"
		],
		"filename": "1f468",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bearded_person"
		],
		"filename": "1f9d4",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"red_haired_man"
		],
		"filename": "1f468-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"curly_haired_man"
		],
		"filename": "1f468-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"white_haired_man"
		],
		"filename": "1f468-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bald_man"
		],
		"filename": "1f468-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"woman"
		],
		"filename": "1f469",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"red_haired_woman"
		],
		"filename": "1f469-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_red_hair"
		],
		"filename": "1f9d1-200d-1f9b0",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"curly_haired_woman"
		],
		"filename": "1f469-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_curly_hair"
		],
		"filename": "1f9d1-200d-1f9b1",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"white_haired_woman"
		],
		"filename": "1f469-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_white_hair"
		],
		"filename": "1f9d1-200d-1f9b3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"bald_woman"
		],
		"filename": "1f469-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"person_bald"
		],
		"filename": "1f9d1-200d-1f9b2",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_woman",
			"blonde_woman"
		],
		"filename": "1f471-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"blond_haired_man",
			"blonde_man"
		],
		"filename": "1f471-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_adult"
		],
		"filename": "1f9d3",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_man"
		],
		"filename": "1f474",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"older_woman"
		],
		"filename": "1f475",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_person",
			"person_frowning"
		],
		"filename": "1f64d",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_man"
		],
		"filename": "1f64d-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"frowning_woman"
		],
		"filename": "1f64d-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_face",
			"person_with_pouting_face"
		],
		"filename": "1f64e",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_man"
		],
		"filename": "1f64e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"pouting_woman"
		],
		"filename": "1f64e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good"
		],
		"filename": "1f645",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good_man",
			"ng_man"
		],
		"filename": "1f645-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"no_good_woman",
			"ng_woman"
		],
		"filename": "1f645-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_person"
		],
		"filename": "1f646",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_man"
		],
		"filename": "1f646-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"ok_woman"
		],
		"filename": "1f646-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_person",
			"information_desk_person"
		],
		"filename": "1f481",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_man",
			"sassy_man"
		],
		"filename": "1f481-200d-2642-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"tipping_hand_woman",
			"sassy_woman"
		],
		"filename": "1f481-200d-2640-fe0f",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"raising_hand"
		],
		"filename": "1f64b",
		"category": "people_body",
		"batch": "2"
	},
	{
		"aliases": [
			"raising_hand_man"
		],
		"filename": "1f64b-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"raising_hand_woman"
		],
		"filename": "1f64b-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_person"
		],
		"filename": "1f9cf",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_man"
		],
		"filename": "1f9cf-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"deaf_woman"
		],
		"filename": "1f9cf-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bow"
		],
		"filename": "1f647",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bowing_man"
		],
		"filename": "1f647-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"bowing_woman"
		],
		"filename": "1f647-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"facepalm"
		],
		"filename": "1f926",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_facepalming"
		],
		"filename": "1f926-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_facepalming"
		],
		"filename": "1f926-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"shrug"
		],
		"filename": "1f937",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_shrugging"
		],
		"filename": "1f937-200d-2642-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_shrugging"
		],
		"filename": "1f937-200d-2640-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"health_worker"
		],
		"filename": "1f9d1-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_health_worker"
		],
		"filename": "1f468-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_health_worker"
		],
		"filename": "1f469-200d-2695-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"student"
		],
		"filename": "1f9d1-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_student"
		],
		"filename": "1f468-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_student"
		],
		"filename": "1f469-200d-1f393",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"teacher"
		],
		"filename": "1f9d1-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_teacher"
		],
		"filename": "1f468-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_teacher"
		],
		"filename": "1f469-200d-1f3eb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"judge"
		],
		"filename": "1f9d1-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_judge"
		],
		"filename": "1f468-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_judge"
		],
		"filename": "1f469-200d-2696-fe0f",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"farmer"
		],
		"filename": "1f9d1-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_farmer"
		],
		"filename": "1f468-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_farmer"
		],
		"filename": "1f469-200d-1f33e",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"cook"
		],
		"filename": "1f9d1-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_cook"
		],
		"filename": "1f468-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_cook"
		],
		"filename": "1f469-200d-1f373",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"mechanic"
		],
		"filename": "1f9d1-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_mechanic"
		],
		"filename": "1f468-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_mechanic"
		],
		"filename": "1f469-200d-1f527",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"factory_worker"
		],
		"filename": "1f9d1-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_factory_worker"
		],
		"filename": "1f468-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_factory_worker"
		],
		"filename": "1f469-200d-1f3ed",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"office_worker"
		],
		"filename": "1f9d1-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_office_worker"
		],
		"filename": "1f468-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_office_worker"
		],
		"filename": "1f469-200d-1f4bc",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"scientist"
		],
		"filename": "1f9d1-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_scientist"
		],
		"filename": "1f468-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"woman_scientist"
		],
		"filename": "1f469-200d-1f52c",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"technologist"
		],
		"filename": "1f9d1-200d-1f4bb",
		"category": "people_body",
		"batch": "3"
	},
	{
		"aliases": [
			"man_technologist"
		],
		"filename": "1f468-200d-1f4bb",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_technologist"
		],
		"filename": "1f469-200d-1f4bb",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"singer"
		],
		"filename": "1f9d1-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_singer"
		],
		"filename": "1f468-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_singer"
		],
		"filename": "1f469-200d-1f3a4",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"artist"
		],
		"filename": "1f9d1-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_artist"
		],
		"filename": "1f468-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_artist"
		],
		"filename": "1f469-200d-1f3a8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"pilot"
		],
		"filename": "1f9d1-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_pilot"
		],
		"filename": "1f468-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_pilot"
		],
		"filename": "1f469-200d-2708-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"astronaut"
		],
		"filename": "1f9d1-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_astronaut"
		],
		"filename": "1f468-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_astronaut"
		],
		"filename": "1f469-200d-1f680",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"firefighter"
		],
		"filename": "1f9d1-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_firefighter"
		],
		"filename": "1f468-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_firefighter"
		],
		"filename": "1f469-200d-1f692",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"police_officer",
			"cop"
		],
		"filename": "1f46e",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"policeman"
		],
		"filename": "1f46e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"policewoman"
		],
		"filename": "1f46e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"detective"
		],
		"filename": "1f575-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"male_detective"
		],
		"filename": "1f575-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"female_detective"
		],
		"filename": "1f575-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guard"
		],
		"filename": "1f482",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guardsman"
		],
		"filename": "1f482-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"guardswoman"
		],
		"filename": "1f482-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker"
		],
		"filename": "1f477",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker_man"
		],
		"filename": "1f477-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"construction_worker_woman"
		],
		"filename": "1f477-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"prince"
		],
		"filename": "1f934",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"princess"
		],
		"filename": "1f478",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"person_with_turban"
		],
		"filename": "1f473",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_with_turban"
		],
		"filename": "1f473-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_with_turban"
		],
		"filename": "1f473-200d-2640-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao"
		],
		"filename": "1f472",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"woman_with_headscarf"
		],
		"filename": "1f9d5",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"man_in_tuxedo"
		],
		"filename": "1f935",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"bride_with_veil"
		],
		"filename": "1f470",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"pregnant_woman"
		],
		"filename": "1f930",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"breast_feeding"
		],
		"filename": "1f931",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"angel"
		],
		"filename": "1f47c",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"santa"
		],
		"filename": "1f385",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"mrs_claus"
		],
		"filename": "1f936",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero"
		],
		"filename": "1f9b8",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero_man"
		],
		"filename": "1f9b8-200d-2642-fe0f",
		"category": "people_body",
		"batch": "4"
	},
	{
		"aliases": [
			"superhero_woman"
		],
		"filename": "1f9b8-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain"
		],
		"filename": "1f9b9",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain_man"
		],
		"filename": "1f9b9-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"supervillain_woman"
		],
		"filename": "1f9b9-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage"
		],
		"filename": "1f9d9",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage_man"
		],
		"filename": "1f9d9-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mage_woman"
		],
		"filename": "1f9d9-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy"
		],
		"filename": "1f9da",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy_man"
		],
		"filename": "1f9da-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"fairy_woman"
		],
		"filename": "1f9da-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire"
		],
		"filename": "1f9db",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire_man"
		],
		"filename": "1f9db-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"vampire_woman"
		],
		"filename": "1f9db-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"merperson"
		],
		"filename": "1f9dc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"merman"
		],
		"filename": "1f9dc-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"mermaid"
		],
		"filename": "1f9dc-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf"
		],
		"filename": "1f9dd",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf_man"
		],
		"filename": "1f9dd-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"elf_woman"
		],
		"filename": "1f9dd-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie"
		],
		"filename": "1f9de",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie_man"
		],
		"filename": "1f9de-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"genie_woman"
		],
		"filename": "1f9de-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie"
		],
		"filename": "1f9df",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie_man"
		],
		"filename": "1f9df-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"zombie_woman"
		],
		"filename": "1f9df-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage"
		],
		"filename": "1f486",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage_man"
		],
		"filename": "1f486-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"massage_woman"
		],
		"filename": "1f486-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut"
		],
		"filename": "1f487",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut_man"
		],
		"filename": "1f487-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"haircut_woman"
		],
		"filename": "1f487-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking"
		],
		"filename": "1f6b6",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking_man"
		],
		"filename": "1f6b6-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"walking_woman"
		],
		"filename": "1f6b6-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_person"
		],
		"filename": "1f9cd",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_man"
		],
		"filename": "1f9cd-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"standing_woman"
		],
		"filename": "1f9cd-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_person"
		],
		"filename": "1f9ce",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_man"
		],
		"filename": "1f9ce-200d-2642-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"kneeling_woman"
		],
		"filename": "1f9ce-200d-2640-fe0f",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"person_with_probing_cane"
		],
		"filename": "1f9d1-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"man_with_probing_cane"
		],
		"filename": "1f468-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"woman_with_probing_cane"
		],
		"filename": "1f469-200d-1f9af",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair"
		],
		"filename": "1f9d1-200d-1f9bc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair"
		],
		"filename": "1f468-200d-1f9bc",
		"category": "people_body",
		"batch": "5"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair"
		],
		"filename": "1f469-200d-1f9bc",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair"
		],
		"filename": "1f9d1-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair"
		],
		"filename": "1f468-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair"
		],
		"filename": "1f469-200d-1f9bd",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"runner",
			"running"
		],
		"filename": "1f3c3",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"running_man"
		],
		"filename": "1f3c3-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"running_woman"
		],
		"filename": "1f3c3-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_dancing",
			"dancer"
		],
		"filename": "1f483",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"man_dancing"
		],
		"filename": "1f57a",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"business_suit_levitating"
		],
		"filename": "1f574",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancers"
		],
		"filename": "1f46f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancing_men"
		],
		"filename": "1f46f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"dancing_women"
		],
		"filename": "1f46f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_person"
		],
		"filename": "1f9d6",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_man"
		],
		"filename": "1f9d6-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"sauna_woman"
		],
		"filename": "1f9d6-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing"
		],
		"filename": "1f9d7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing_man"
		],
		"filename": "1f9d7-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"climbing_woman"
		],
		"filename": "1f9d7-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"person_fencing"
		],
		"filename": "1f93a",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"horse_racing"
		],
		"filename": "1f3c7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"skier"
		],
		"filename": "26f7",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"snowboarder"
		],
		"filename": "1f3c2",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing"
		],
		"filename": "1f3cc-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing_man"
		],
		"filename": "1f3cc-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"golfing_woman"
		],
		"filename": "1f3cc-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfer"
		],
		"filename": "1f3c4",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfing_man"
		],
		"filename": "1f3c4-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"surfing_woman"
		],
		"filename": "1f3c4-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowboat"
		],
		"filename": "1f6a3",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowing_man"
		],
		"filename": "1f6a3-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"rowing_woman"
		],
		"filename": "1f6a3-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimmer"
		],
		"filename": "1f3ca",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimming_man"
		],
		"filename": "1f3ca-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"swimming_woman"
		],
		"filename": "1f3ca-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_person"
		],
		"filename": "26f9-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_man",
			"basketball_man"
		],
		"filename": "26f9-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bouncing_ball_woman",
			"basketball_woman"
		],
		"filename": "26f9-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting"
		],
		"filename": "1f3cb-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting_man"
		],
		"filename": "1f3cb-fe0f-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"weight_lifting_woman"
		],
		"filename": "1f3cb-fe0f-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"bicyclist"
		],
		"filename": "1f6b4",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"biking_man"
		],
		"filename": "1f6b4-200d-2642-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"biking_woman"
		],
		"filename": "1f6b4-200d-2640-fe0f",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"mountain_bicyclist"
		],
		"filename": "1f6b5",
		"category": "people_body",
		"batch": "6"
	},
	{
		"aliases": [
			"mountain_biking_man"
		],
		"filename": "1f6b5-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"mountain_biking_woman"
		],
		"filename": "1f6b5-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"cartwheeling"
		],
		"filename": "1f938",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_cartwheeling"
		],
		"filename": "1f938-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_cartwheeling"
		],
		"filename": "1f938-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"wrestling"
		],
		"filename": "1f93c",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"men_wrestling"
		],
		"filename": "1f93c-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"women_wrestling"
		],
		"filename": "1f93c-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"water_polo"
		],
		"filename": "1f93d",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_playing_water_polo"
		],
		"filename": "1f93d-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_playing_water_polo"
		],
		"filename": "1f93d-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"handball_person"
		],
		"filename": "1f93e",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_playing_handball"
		],
		"filename": "1f93e-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_playing_handball"
		],
		"filename": "1f93e-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"juggling_person"
		],
		"filename": "1f939",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"man_juggling"
		],
		"filename": "1f939-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"woman_juggling"
		],
		"filename": "1f939-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position"
		],
		"filename": "1f9d8",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position_man"
		],
		"filename": "1f9d8-200d-2642-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"lotus_position_woman"
		],
		"filename": "1f9d8-200d-2640-fe0f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"bath"
		],
		"filename": "1f6c0",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"sleeping_bed"
		],
		"filename": "1f6cc",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"people_holding_hands"
		],
		"filename": "1f9d1-200d-1f91d-200d-1f9d1",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"two_women_holding_hands"
		],
		"filename": "1f46d",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple"
		],
		"filename": "1f46b",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"two_men_holding_hands"
		],
		"filename": "1f46c",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss"
		],
		"filename": "1f48f",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_man_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_man_man"
		],
		"filename": "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couplekiss_woman_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart"
		],
		"filename": "1f491",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_woman_man"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_man_man"
		],
		"filename": "1f468-200d-2764-fe0f-200d-1f468",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"couple_with_heart_woman_woman"
		],
		"filename": "1f469-200d-2764-fe0f-200d-1f469",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family"
		],
		"filename": "1f46a",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl"
		],
		"filename": "1f468-200d-1f469-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_boy_boy"
		],
		"filename": "1f468-200d-1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_woman_girl_girl"
		],
		"filename": "1f468-200d-1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl"
		],
		"filename": "1f468-200d-1f468-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_boy_boy"
		],
		"filename": "1f468-200d-1f468-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_man_man_girl_girl"
		],
		"filename": "1f468-200d-1f468-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "7"
	},
	{
		"aliases": [
			"family_woman_woman_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl"
		],
		"filename": "1f469-200d-1f469-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_boy_boy"
		],
		"filename": "1f469-200d-1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_woman_girl_girl"
		],
		"filename": "1f469-200d-1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_boy"
		],
		"filename": "1f468-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_boy_boy"
		],
		"filename": "1f468-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl"
		],
		"filename": "1f468-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl_boy"
		],
		"filename": "1f468-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_man_girl_girl"
		],
		"filename": "1f468-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_boy"
		],
		"filename": "1f469-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_boy_boy"
		],
		"filename": "1f469-200d-1f466-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl"
		],
		"filename": "1f469-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl_boy"
		],
		"filename": "1f469-200d-1f467-200d-1f466",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"family_woman_girl_girl"
		],
		"filename": "1f469-200d-1f467-200d-1f467",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"speaking_head"
		],
		"filename": "1f5e3",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"bust_in_silhouette"
		],
		"filename": "1f464",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"busts_in_silhouette"
		],
		"filename": "1f465",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"footprints"
		],
		"filename": "1f463",
		"category": "people_body",
		"batch": "8"
	},
	{
		"aliases": [
			"monkey_face"
		],
		"filename": "1f435",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"monkey"
		],
		"filename": "1f412",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"gorilla"
		],
		"filename": "1f98d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"orangutan"
		],
		"filename": "1f9a7",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dog"
		],
		"filename": "1f436",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dog2"
		],
		"filename": "1f415",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"guide_dog"
		],
		"filename": "1f9ae",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"service_dog"
		],
		"filename": "1f415-200d-1f9ba",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"poodle"
		],
		"filename": "1f429",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"wolf"
		],
		"filename": "1f43a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"fox_face"
		],
		"filename": "1f98a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"raccoon"
		],
		"filename": "1f99d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cat"
		],
		"filename": "1f431",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cat2"
		],
		"filename": "1f408",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"lion"
		],
		"filename": "1f981",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"tiger"
		],
		"filename": "1f42f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"tiger2"
		],
		"filename": "1f405",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"leopard"
		],
		"filename": "1f406",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"horse"
		],
		"filename": "1f434",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"racehorse"
		],
		"filename": "1f40e",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"unicorn"
		],
		"filename": "1f984",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"zebra"
		],
		"filename": "1f993",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"deer"
		],
		"filename": "1f98c",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cow"
		],
		"filename": "1f42e",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"ox"
		],
		"filename": "1f402",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"water_buffalo"
		],
		"filename": "1f403",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"cow2"
		],
		"filename": "1f404",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig"
		],
		"filename": "1f437",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig2"
		],
		"filename": "1f416",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"boar"
		],
		"filename": "1f417",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"pig_nose"
		],
		"filename": "1f43d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"ram"
		],
		"filename": "1f40f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"sheep"
		],
		"filename": "1f411",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"goat"
		],
		"filename": "1f410",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"dromedary_camel"
		],
		"filename": "1f42a",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"camel"
		],
		"filename": "1f42b",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"llama"
		],
		"filename": "1f999",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"giraffe"
		],
		"filename": "1f992",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"elephant"
		],
		"filename": "1f418",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rhinoceros"
		],
		"filename": "1f98f",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"hippopotamus"
		],
		"filename": "1f99b",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"mouse"
		],
		"filename": "1f42d",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"mouse2"
		],
		"filename": "1f401",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rat"
		],
		"filename": "1f400",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"hamster"
		],
		"filename": "1f439",
		"category": "animals_nature",
		"batch": "1"
	},
	{
		"aliases": [
			"rabbit"
		],
		"filename": "1f430",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"rabbit2"
		],
		"filename": "1f407",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"chipmunk"
		],
		"filename": "1f43f",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hedgehog"
		],
		"filename": "1f994",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bat"
		],
		"filename": "1f987",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bear"
		],
		"filename": "1f43b",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"koala"
		],
		"filename": "1f428",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"panda_face"
		],
		"filename": "1f43c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"sloth"
		],
		"filename": "1f9a5",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"otter"
		],
		"filename": "1f9a6",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"skunk"
		],
		"filename": "1f9a8",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"kangaroo"
		],
		"filename": "1f998",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"badger"
		],
		"filename": "1f9a1",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"feet",
			"paw_prints"
		],
		"filename": "1f43e",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"turkey"
		],
		"filename": "1f983",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"chicken"
		],
		"filename": "1f414",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"rooster"
		],
		"filename": "1f413",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hatching_chick"
		],
		"filename": "1f423",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"baby_chick"
		],
		"filename": "1f424",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"hatched_chick"
		],
		"filename": "1f425",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"bird"
		],
		"filename": "1f426",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"penguin"
		],
		"filename": "1f427",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dove"
		],
		"filename": "1f54a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"eagle"
		],
		"filename": "1f985",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"duck"
		],
		"filename": "1f986",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"swan"
		],
		"filename": "1f9a2",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"owl"
		],
		"filename": "1f989",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"flamingo"
		],
		"filename": "1f9a9",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"peacock"
		],
		"filename": "1f99a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"parrot"
		],
		"filename": "1f99c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"frog"
		],
		"filename": "1f438",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"crocodile"
		],
		"filename": "1f40a",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"turtle"
		],
		"filename": "1f422",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"lizard"
		],
		"filename": "1f98e",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"snake"
		],
		"filename": "1f40d",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dragon_face"
		],
		"filename": "1f432",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dragon"
		],
		"filename": "1f409",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"sauropod"
		],
		"filename": "1f995",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"t-rex"
		],
		"filename": "1f996",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"whale"
		],
		"filename": "1f433",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"whale2"
		],
		"filename": "1f40b",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"dolphin",
			"flipper"
		],
		"filename": "1f42c",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"fish"
		],
		"filename": "1f41f",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"tropical_fish"
		],
		"filename": "1f420",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"blowfish"
		],
		"filename": "1f421",
		"category": "animals_nature",
		"batch": "2"
	},
	{
		"aliases": [
			"shark"
		],
		"filename": "1f988",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"octopus"
		],
		"filename": "1f419",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"shell"
		],
		"filename": "1f41a",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"snail"
		],
		"filename": "1f40c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"butterfly"
		],
		"filename": "1f98b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bug"
		],
		"filename": "1f41b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"ant"
		],
		"filename": "1f41c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bee",
			"honeybee"
		],
		"filename": "1f41d",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"beetle"
		],
		"filename": "1f41e",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cricket"
		],
		"filename": "1f997",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"spider"
		],
		"filename": "1f577",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"spider_web"
		],
		"filename": "1f578",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"scorpion"
		],
		"filename": "1f982",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"mosquito"
		],
		"filename": "1f99f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"microbe"
		],
		"filename": "1f9a0",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"bouquet"
		],
		"filename": "1f490",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cherry_blossom"
		],
		"filename": "1f338",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"white_flower"
		],
		"filename": "1f4ae",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"rosette"
		],
		"filename": "1f3f5",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"rose"
		],
		"filename": "1f339",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"wilted_flower"
		],
		"filename": "1f940",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"hibiscus"
		],
		"filename": "1f33a",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"sunflower"
		],
		"filename": "1f33b",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"blossom"
		],
		"filename": "1f33c",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"tulip"
		],
		"filename": "1f337",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"seedling"
		],
		"filename": "1f331",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"evergreen_tree"
		],
		"filename": "1f332",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"deciduous_tree"
		],
		"filename": "1f333",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"palm_tree"
		],
		"filename": "1f334",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"cactus"
		],
		"filename": "1f335",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"ear_of_rice"
		],
		"filename": "1f33e",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"herb"
		],
		"filename": "1f33f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"shamrock"
		],
		"filename": "2618-fe0f",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"four_leaf_clover"
		],
		"filename": "1f340",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"maple_leaf"
		],
		"filename": "1f341",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"fallen_leaf"
		],
		"filename": "1f342",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"leaves"
		],
		"filename": "1f343",
		"category": "animals_nature",
		"batch": "3"
	},
	{
		"aliases": [
			"grapes"
		],
		"filename": "1f347",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"melon"
		],
		"filename": "1f348",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"watermelon"
		],
		"filename": "1f349",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"tangerine",
			"orange",
			"mandarin"
		],
		"filename": "1f34a",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"lemon"
		],
		"filename": "1f34b",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"banana"
		],
		"filename": "1f34c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pineapple"
		],
		"filename": "1f34d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"mango"
		],
		"filename": "1f96d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"apple"
		],
		"filename": "1f34e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"green_apple"
		],
		"filename": "1f34f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pear"
		],
		"filename": "1f350",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"peach"
		],
		"filename": "1f351",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cherries"
		],
		"filename": "1f352",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"strawberry"
		],
		"filename": "1f353",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"kiwi_fruit"
		],
		"filename": "1f95d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"tomato"
		],
		"filename": "1f345",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"coconut"
		],
		"filename": "1f965",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"avocado"
		],
		"filename": "1f951",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"eggplant"
		],
		"filename": "1f346",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"potato"
		],
		"filename": "1f954",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"carrot"
		],
		"filename": "1f955",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"corn"
		],
		"filename": "1f33d",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"hot_pepper"
		],
		"filename": "1f336",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cucumber"
		],
		"filename": "1f952",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"leafy_green"
		],
		"filename": "1f96c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"broccoli"
		],
		"filename": "1f966",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"garlic"
		],
		"filename": "1f9c4",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"onion"
		],
		"filename": "1f9c5",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"mushroom"
		],
		"filename": "1f344",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"peanuts"
		],
		"filename": "1f95c",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"chestnut"
		],
		"filename": "1f330",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bread"
		],
		"filename": "1f35e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"croissant"
		],
		"filename": "1f950",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"baguette_bread"
		],
		"filename": "1f956",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pretzel"
		],
		"filename": "1f968",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bagel"
		],
		"filename": "1f96f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pancakes"
		],
		"filename": "1f95e",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"waffle"
		],
		"filename": "1f9c7",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cheese"
		],
		"filename": "1f9c0",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"meat_on_bone"
		],
		"filename": "1f356",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"poultry_leg"
		],
		"filename": "1f357",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"cut_of_meat"
		],
		"filename": "1f969",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"bacon"
		],
		"filename": "1f953",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"hamburger"
		],
		"filename": "1f354",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"fries"
		],
		"filename": "1f35f",
		"category": "food_drink",
		"batch": "1"
	},
	{
		"aliases": [
			"pizza"
		],
		"filename": "1f355",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"hotdog"
		],
		"filename": "1f32d",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sandwich"
		],
		"filename": "1f96a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"taco"
		],
		"filename": "1f32e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"burrito"
		],
		"filename": "1f32f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"stuffed_flatbread"
		],
		"filename": "1f959",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"falafel"
		],
		"filename": "1f9c6",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"egg"
		],
		"filename": "1f95a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fried_egg"
		],
		"filename": "1f373",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shallow_pan_of_food"
		],
		"filename": "1f958",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"stew"
		],
		"filename": "1f372",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"bowl_with_spoon"
		],
		"filename": "1f963",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"green_salad"
		],
		"filename": "1f957",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"popcorn"
		],
		"filename": "1f37f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"butter"
		],
		"filename": "1f9c8",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"salt"
		],
		"filename": "1f9c2",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"canned_food"
		],
		"filename": "1f96b",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"bento"
		],
		"filename": "1f371",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice_cracker"
		],
		"filename": "1f358",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice_ball"
		],
		"filename": "1f359",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"rice"
		],
		"filename": "1f35a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"curry"
		],
		"filename": "1f35b",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"ramen"
		],
		"filename": "1f35c",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"spaghetti"
		],
		"filename": "1f35d",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sweet_potato"
		],
		"filename": "1f360",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"oden"
		],
		"filename": "1f362",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"sushi"
		],
		"filename": "1f363",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fried_shrimp"
		],
		"filename": "1f364",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fish_cake"
		],
		"filename": "1f365",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"moon_cake"
		],
		"filename": "1f96e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"dango"
		],
		"filename": "1f361",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"dumpling"
		],
		"filename": "1f95f",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"fortune_cookie"
		],
		"filename": "1f960",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"takeout_box"
		],
		"filename": "1f961",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"crab"
		],
		"filename": "1f980",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"lobster"
		],
		"filename": "1f99e",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shrimp"
		],
		"filename": "1f990",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"squid"
		],
		"filename": "1f991",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"oyster"
		],
		"filename": "1f9aa",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"icecream"
		],
		"filename": "1f366",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"shaved_ice"
		],
		"filename": "1f367",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"ice_cream"
		],
		"filename": "1f368",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"doughnut"
		],
		"filename": "1f369",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"cookie"
		],
		"filename": "1f36a",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"birthday"
		],
		"filename": "1f382",
		"category": "food_drink",
		"batch": "2"
	},
	{
		"aliases": [
			"cake"
		],
		"filename": "1f370",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cupcake"
		],
		"filename": "1f9c1",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"pie"
		],
		"filename": "1f967",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"chocolate_bar"
		],
		"filename": "1f36b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"candy"
		],
		"filename": "1f36c",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"lollipop"
		],
		"filename": "1f36d",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"custard"
		],
		"filename": "1f36e",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"honey_pot"
		],
		"filename": "1f36f",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"baby_bottle"
		],
		"filename": "1f37c",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"milk_glass"
		],
		"filename": "1f95b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"coffee"
		],
		"filename": "2615",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tea"
		],
		"filename": "1f375",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"sake"
		],
		"filename": "1f376",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"champagne"
		],
		"filename": "1f37e",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"wine_glass"
		],
		"filename": "1f377",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cocktail"
		],
		"filename": "1f378",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tropical_drink"
		],
		"filename": "1f379",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beer"
		],
		"filename": "1f37a",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beers"
		],
		"filename": "1f37b",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"clinking_glasses"
		],
		"filename": "1f942",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"tumbler_glass"
		],
		"filename": "1f943",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"cup_with_straw"
		],
		"filename": "1f964",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"beverage_box"
		],
		"filename": "1f9c3",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"mate"
		],
		"filename": "1f9c9",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"ice_cube"
		],
		"filename": "1f9ca",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"chopsticks"
		],
		"filename": "1f962",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"plate_with_cutlery"
		],
		"filename": "1f37d",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"fork_and_knife"
		],
		"filename": "1f374",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"spoon"
		],
		"filename": "1f944",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"hocho",
			"knife"
		],
		"filename": "1f52a",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"amphora"
		],
		"filename": "1f3fa",
		"category": "food_drink",
		"batch": "3"
	},
	{
		"aliases": [
			"earth_africa"
		],
		"filename": "1f30d",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"earth_americas"
		],
		"filename": "1f30e",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"earth_asia"
		],
		"filename": "1f30f",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"globe_with_meridians"
		],
		"filename": "1f310",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"world_map"
		],
		"filename": "1f5fa",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"japan"
		],
		"filename": "1f5fe",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"compass"
		],
		"filename": "1f9ed",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mountain_snow"
		],
		"filename": "1f3d4",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mountain"
		],
		"filename": "26f0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"volcano"
		],
		"filename": "1f30b",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mount_fuji"
		],
		"filename": "1f5fb",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"camping"
		],
		"filename": "1f3d5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"beach_umbrella"
		],
		"filename": "1f3d6",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"desert"
		],
		"filename": "1f3dc",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"desert_island"
		],
		"filename": "1f3dd",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"national_park"
		],
		"filename": "1f3de",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"stadium"
		],
		"filename": "1f3df",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"classical_building"
		],
		"filename": "1f3db",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"building_construction"
		],
		"filename": "1f3d7",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"bricks"
		],
		"filename": "1f9f1",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"houses"
		],
		"filename": "1f3d8",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"derelict_house"
		],
		"filename": "1f3da",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"house"
		],
		"filename": "1f3e0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"house_with_garden"
		],
		"filename": "1f3e1",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"office"
		],
		"filename": "1f3e2",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"post_office"
		],
		"filename": "1f3e3",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"european_post_office"
		],
		"filename": "1f3e4",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hospital"
		],
		"filename": "1f3e5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"bank"
		],
		"filename": "1f3e6",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hotel"
		],
		"filename": "1f3e8",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"love_hotel"
		],
		"filename": "1f3e9",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"convenience_store"
		],
		"filename": "1f3ea",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"school"
		],
		"filename": "1f3eb",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"department_store"
		],
		"filename": "1f3ec",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"factory"
		],
		"filename": "1f3ed",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"japanese_castle"
		],
		"filename": "1f3ef",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"european_castle"
		],
		"filename": "1f3f0",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"wedding"
		],
		"filename": "1f492",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"tokyo_tower"
		],
		"filename": "1f5fc",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"statue_of_liberty"
		],
		"filename": "1f5fd",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"church"
		],
		"filename": "26ea",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"mosque"
		],
		"filename": "1f54c",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"hindu_temple"
		],
		"filename": "1f6d5",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"synagogue"
		],
		"filename": "1f54d",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"shinto_shrine"
		],
		"filename": "26e9",
		"category": "travel_places",
		"batch": "1"
	},
	{
		"aliases": [
			"kaaba"
		],
		"filename": "1f54b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"fountain"
		],
		"filename": "26f2",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tent"
		],
		"filename": "26fa",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"foggy"
		],
		"filename": "1f301",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"night_with_stars"
		],
		"filename": "1f303",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"cityscape"
		],
		"filename": "1f3d9",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"sunrise_over_mountains"
		],
		"filename": "1f304",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"sunrise"
		],
		"filename": "1f305",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"city_sunset"
		],
		"filename": "1f306",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"city_sunrise"
		],
		"filename": "1f307",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bridge_at_night"
		],
		"filename": "1f309",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"hotsprings"
		],
		"filename": "2668-fe0f",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"carousel_horse"
		],
		"filename": "1f3a0",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"ferris_wheel"
		],
		"filename": "1f3a1",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"roller_coaster"
		],
		"filename": "1f3a2",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"barber"
		],
		"filename": "1f488",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"circus_tent"
		],
		"filename": "1f3aa",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"steam_locomotive"
		],
		"filename": "1f682",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"railway_car"
		],
		"filename": "1f683",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bullettrain_side"
		],
		"filename": "1f684",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bullettrain_front"
		],
		"filename": "1f685",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"train2"
		],
		"filename": "1f686",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"metro"
		],
		"filename": "1f687",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"light_rail"
		],
		"filename": "1f688",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"station"
		],
		"filename": "1f689",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tram"
		],
		"filename": "1f68a",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"monorail"
		],
		"filename": "1f69d",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"mountain_railway"
		],
		"filename": "1f69e",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"train"
		],
		"filename": "1f68b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"bus"
		],
		"filename": "1f68c",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_bus"
		],
		"filename": "1f68d",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"trolleybus"
		],
		"filename": "1f68e",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"minibus"
		],
		"filename": "1f690",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"ambulance"
		],
		"filename": "1f691",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"fire_engine"
		],
		"filename": "1f692",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"police_car"
		],
		"filename": "1f693",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_police_car"
		],
		"filename": "1f694",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"taxi"
		],
		"filename": "1f695",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_taxi"
		],
		"filename": "1f696",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"car",
			"red_car"
		],
		"filename": "1f697",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"oncoming_automobile"
		],
		"filename": "1f698",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"blue_car"
		],
		"filename": "1f699",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"truck"
		],
		"filename": "1f69a",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"articulated_lorry"
		],
		"filename": "1f69b",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"tractor"
		],
		"filename": "1f69c",
		"category": "travel_places",
		"batch": "2"
	},
	{
		"aliases": [
			"racing_car"
		],
		"filename": "1f3ce",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorcycle"
		],
		"filename": "1f3cd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motor_scooter"
		],
		"filename": "1f6f5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"manual_wheelchair"
		],
		"filename": "1f9bd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorized_wheelchair"
		],
		"filename": "1f9bc",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"auto_rickshaw"
		],
		"filename": "1f6fa",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"bike"
		],
		"filename": "1f6b2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"kick_scooter"
		],
		"filename": "1f6f4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"skateboard"
		],
		"filename": "1f6f9",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"busstop"
		],
		"filename": "1f68f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motorway"
		],
		"filename": "1f6e3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"railway_track"
		],
		"filename": "1f6e4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"oil_drum"
		],
		"filename": "1f6e2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"fuelpump"
		],
		"filename": "26fd",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"rotating_light"
		],
		"filename": "1f6a8",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"traffic_light"
		],
		"filename": "1f6a5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"vertical_traffic_light"
		],
		"filename": "1f6a6",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"stop_sign"
		],
		"filename": "1f6d1",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"construction"
		],
		"filename": "1f6a7",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"anchor"
		],
		"filename": "2693",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"boat",
			"sailboat"
		],
		"filename": "26f5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"canoe"
		],
		"filename": "1f6f6",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"speedboat"
		],
		"filename": "1f6a4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"passenger_ship"
		],
		"filename": "1f6f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"ferry"
		],
		"filename": "26f4",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"motor_boat"
		],
		"filename": "1f6e5",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"ship"
		],
		"filename": "1f6a2",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"airplane"
		],
		"filename": "2708-fe0f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"small_airplane"
		],
		"filename": "1f6e9",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flight_departure"
		],
		"filename": "1f6eb",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flight_arrival"
		],
		"filename": "1f6ec",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"parachute"
		],
		"filename": "1fa82",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"seat"
		],
		"filename": "1f4ba",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"helicopter"
		],
		"filename": "1f681",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"suspension_railway"
		],
		"filename": "1f69f",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"mountain_cableway"
		],
		"filename": "1f6a0",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"aerial_tramway"
		],
		"filename": "1f6a1",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"artificial_satellite"
		],
		"filename": "1f6f0",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"rocket"
		],
		"filename": "1f680",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"flying_saucer"
		],
		"filename": "1f6f8",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"bellhop_bell"
		],
		"filename": "1f6ce",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"luggage"
		],
		"filename": "1f9f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"hourglass"
		],
		"filename": "231b",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"hourglass_flowing_sand"
		],
		"filename": "23f3",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"watch"
		],
		"filename": "231a",
		"category": "travel_places",
		"batch": "3"
	},
	{
		"aliases": [
			"alarm_clock"
		],
		"filename": "23f0",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"stopwatch"
		],
		"filename": "23f1",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"timer_clock"
		],
		"filename": "23f2",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"mantelpiece_clock"
		],
		"filename": "1f570",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock12"
		],
		"filename": "1f55b",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1230"
		],
		"filename": "1f567",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1"
		],
		"filename": "1f550",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock130"
		],
		"filename": "1f55c",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock2"
		],
		"filename": "1f551",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock230"
		],
		"filename": "1f55d",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock3"
		],
		"filename": "1f552",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock330"
		],
		"filename": "1f55e",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock4"
		],
		"filename": "1f553",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock430"
		],
		"filename": "1f55f",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock5"
		],
		"filename": "1f554",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock530"
		],
		"filename": "1f560",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock6"
		],
		"filename": "1f555",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock630"
		],
		"filename": "1f561",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock7"
		],
		"filename": "1f556",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock730"
		],
		"filename": "1f562",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock8"
		],
		"filename": "1f557",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock830"
		],
		"filename": "1f563",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock9"
		],
		"filename": "1f558",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock930"
		],
		"filename": "1f564",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock10"
		],
		"filename": "1f559",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1030"
		],
		"filename": "1f565",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock11"
		],
		"filename": "1f55a",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"clock1130"
		],
		"filename": "1f566",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"new_moon"
		],
		"filename": "1f311",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waxing_crescent_moon"
		],
		"filename": "1f312",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"first_quarter_moon"
		],
		"filename": "1f313",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"moon",
			"waxing_gibbous_moon"
		],
		"filename": "1f314",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"full_moon"
		],
		"filename": "1f315",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waning_gibbous_moon"
		],
		"filename": "1f316",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"last_quarter_moon"
		],
		"filename": "1f317",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"waning_crescent_moon"
		],
		"filename": "1f318",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"crescent_moon"
		],
		"filename": "1f319",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"new_moon_with_face"
		],
		"filename": "1f31a",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"first_quarter_moon_with_face"
		],
		"filename": "1f31b",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"last_quarter_moon_with_face"
		],
		"filename": "1f31c",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"thermometer"
		],
		"filename": "1f321",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"sunny"
		],
		"filename": "2600-fe0f",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"full_moon_with_face"
		],
		"filename": "1f31d",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"sun_with_face"
		],
		"filename": "1f31e",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"ringed_planet"
		],
		"filename": "1fa90",
		"category": "travel_places",
		"batch": "4"
	},
	{
		"aliases": [
			"star"
		],
		"filename": "2b50",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"star2"
		],
		"filename": "1f31f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"stars"
		],
		"filename": "1f320",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"milky_way"
		],
		"filename": "1f30c",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud"
		],
		"filename": "2601-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"partly_sunny"
		],
		"filename": "26c5",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_lightning_and_rain"
		],
		"filename": "26c8",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_small_cloud"
		],
		"filename": "1f324",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_large_cloud"
		],
		"filename": "1f325",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"sun_behind_rain_cloud"
		],
		"filename": "1f326",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_rain"
		],
		"filename": "1f327",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_snow"
		],
		"filename": "1f328",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cloud_with_lightning"
		],
		"filename": "1f329",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"tornado"
		],
		"filename": "1f32a",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"fog"
		],
		"filename": "1f32b",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"wind_face"
		],
		"filename": "1f32c",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"cyclone"
		],
		"filename": "1f300",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"rainbow"
		],
		"filename": "1f308",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"closed_umbrella"
		],
		"filename": "1f302",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"open_umbrella"
		],
		"filename": "2602-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"umbrella"
		],
		"filename": "2614",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"parasol_on_ground"
		],
		"filename": "26f1",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"zap"
		],
		"filename": "26a1",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowflake"
		],
		"filename": "2744-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowman_with_snow"
		],
		"filename": "2603-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"snowman"
		],
		"filename": "26c4",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"comet"
		],
		"filename": "2604-fe0f",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"fire"
		],
		"filename": "1f525",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"droplet"
		],
		"filename": "1f4a7",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"ocean"
		],
		"filename": "1f30a",
		"category": "travel_places",
		"batch": "5"
	},
	{
		"aliases": [
			"jack_o_lantern"
		],
		"filename": "1f383",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"christmas_tree"
		],
		"filename": "1f384",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"fireworks"
		],
		"filename": "1f386",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"sparkler"
		],
		"filename": "1f387",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"firecracker"
		],
		"filename": "1f9e8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"sparkles"
		],
		"filename": "2728",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"balloon"
		],
		"filename": "1f388",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tada"
		],
		"filename": "1f389",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"confetti_ball"
		],
		"filename": "1f38a",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tanabata_tree"
		],
		"filename": "1f38b",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"bamboo"
		],
		"filename": "1f38d",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"dolls"
		],
		"filename": "1f38e",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"flags"
		],
		"filename": "1f38f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"wind_chime"
		],
		"filename": "1f390",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"rice_scene"
		],
		"filename": "1f391",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"red_envelope"
		],
		"filename": "1f9e7",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ribbon"
		],
		"filename": "1f380",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"gift"
		],
		"filename": "1f381",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"reminder_ribbon"
		],
		"filename": "1f397",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tickets"
		],
		"filename": "1f39f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ticket"
		],
		"filename": "1f3ab",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"medal_military"
		],
		"filename": "1f396",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"trophy"
		],
		"filename": "1f3c6",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"medal_sports"
		],
		"filename": "1f3c5",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"1st_place_medal"
		],
		"filename": "1f947",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"2nd_place_medal"
		],
		"filename": "1f948",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"3rd_place_medal"
		],
		"filename": "1f949",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"soccer"
		],
		"filename": "26bd",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"baseball"
		],
		"filename": "26be",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"softball"
		],
		"filename": "1f94e",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"basketball"
		],
		"filename": "1f3c0",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"volleyball"
		],
		"filename": "1f3d0",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"football"
		],
		"filename": "1f3c8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"rugby_football"
		],
		"filename": "1f3c9",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"tennis"
		],
		"filename": "1f3be",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"flying_disc"
		],
		"filename": "1f94f",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"bowling"
		],
		"filename": "1f3b3",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"cricket_game"
		],
		"filename": "1f3cf",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"field_hockey"
		],
		"filename": "1f3d1",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ice_hockey"
		],
		"filename": "1f3d2",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"lacrosse"
		],
		"filename": "1f94d",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"ping_pong"
		],
		"filename": "1f3d3",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"badminton"
		],
		"filename": "1f3f8",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"boxing_glove"
		],
		"filename": "1f94a",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"martial_arts_uniform"
		],
		"filename": "1f94b",
		"category": "activities",
		"batch": "1"
	},
	{
		"aliases": [
			"goal_net"
		],
		"filename": "1f945",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"golf"
		],
		"filename": "26f3",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"ice_skate"
		],
		"filename": "26f8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"fishing_pole_and_fish"
		],
		"filename": "1f3a3",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"diving_mask"
		],
		"filename": "1f93f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"running_shirt_with_sash"
		],
		"filename": "1f3bd",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"ski"
		],
		"filename": "1f3bf",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"sled"
		],
		"filename": "1f6f7",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"curling_stone"
		],
		"filename": "1f94c",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"dart"
		],
		"filename": "1f3af",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"yo_yo"
		],
		"filename": "1fa80",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"kite"
		],
		"filename": "1fa81",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"8ball"
		],
		"filename": "1f3b1",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"crystal_ball"
		],
		"filename": "1f52e",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"nazar_amulet"
		],
		"filename": "1f9ff",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"video_game"
		],
		"filename": "1f3ae",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"joystick"
		],
		"filename": "1f579",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"slot_machine"
		],
		"filename": "1f3b0",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"game_die"
		],
		"filename": "1f3b2",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"jigsaw"
		],
		"filename": "1f9e9",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"teddy_bear"
		],
		"filename": "1f9f8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"spades"
		],
		"filename": "2660-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"hearts"
		],
		"filename": "2665-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"diamonds"
		],
		"filename": "2666-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"clubs"
		],
		"filename": "2663-fe0f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"chess_pawn"
		],
		"filename": "265f",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"black_joker"
		],
		"filename": "1f0cf",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"mahjong"
		],
		"filename": "1f004",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"flower_playing_cards"
		],
		"filename": "1f3b4",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"performing_arts"
		],
		"filename": "1f3ad",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"framed_picture"
		],
		"filename": "1f5bc",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"art"
		],
		"filename": "1f3a8",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"thread"
		],
		"filename": "1f9f5",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"yarn"
		],
		"filename": "1f9f6",
		"category": "activities",
		"batch": "2"
	},
	{
		"aliases": [
			"eyeglasses"
		],
		"filename": "1f453",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"dark_sunglasses"
		],
		"filename": "1f576",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"goggles"
		],
		"filename": "1f97d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"lab_coat"
		],
		"filename": "1f97c",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"safety_vest"
		],
		"filename": "1f9ba",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"necktie"
		],
		"filename": "1f454",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shirt",
			"tshirt"
		],
		"filename": "1f455",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"jeans"
		],
		"filename": "1f456",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"scarf"
		],
		"filename": "1f9e3",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"gloves"
		],
		"filename": "1f9e4",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"coat"
		],
		"filename": "1f9e5",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"socks"
		],
		"filename": "1f9e6",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"dress"
		],
		"filename": "1f457",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"kimono"
		],
		"filename": "1f458",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sari"
		],
		"filename": "1f97b",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"one_piece_swimsuit"
		],
		"filename": "1fa71",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"swim_brief"
		],
		"filename": "1fa72",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shorts"
		],
		"filename": "1fa73",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"bikini"
		],
		"filename": "1f459",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"womans_clothes"
		],
		"filename": "1f45a",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"purse"
		],
		"filename": "1f45b",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"handbag"
		],
		"filename": "1f45c",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"pouch"
		],
		"filename": "1f45d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"shopping"
		],
		"filename": "1f6cd",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"school_satchel"
		],
		"filename": "1f392",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mans_shoe",
			"shoe"
		],
		"filename": "1f45e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"athletic_shoe"
		],
		"filename": "1f45f",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"hiking_boot"
		],
		"filename": "1f97e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"flat_shoe"
		],
		"filename": "1f97f",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"high_heel"
		],
		"filename": "1f460",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sandal"
		],
		"filename": "1f461",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"ballet_shoes"
		],
		"filename": "1fa70",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"boot"
		],
		"filename": "1f462",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"crown"
		],
		"filename": "1f451",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"womans_hat"
		],
		"filename": "1f452",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"tophat"
		],
		"filename": "1f3a9",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mortar_board"
		],
		"filename": "1f393",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"billed_cap"
		],
		"filename": "1f9e2",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"rescue_worker_helmet"
		],
		"filename": "26d1",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"prayer_beads"
		],
		"filename": "1f4ff",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"lipstick"
		],
		"filename": "1f484",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"ring"
		],
		"filename": "1f48d",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"gem"
		],
		"filename": "1f48e",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"mute"
		],
		"filename": "1f507",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"speaker"
		],
		"filename": "1f508",
		"category": "objects",
		"batch": "1"
	},
	{
		"aliases": [
			"sound"
		],
		"filename": "1f509",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"loud_sound"
		],
		"filename": "1f50a",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"loudspeaker"
		],
		"filename": "1f4e2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"mega"
		],
		"filename": "1f4e3",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"postal_horn"
		],
		"filename": "1f4ef",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"bell"
		],
		"filename": "1f514",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"no_bell"
		],
		"filename": "1f515",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_score"
		],
		"filename": "1f3bc",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_note"
		],
		"filename": "1f3b5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"notes"
		],
		"filename": "1f3b6",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"studio_microphone"
		],
		"filename": "1f399",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"level_slider"
		],
		"filename": "1f39a",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"control_knobs"
		],
		"filename": "1f39b",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"microphone"
		],
		"filename": "1f3a4",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"headphones"
		],
		"filename": "1f3a7",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"radio"
		],
		"filename": "1f4fb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"saxophone"
		],
		"filename": "1f3b7",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"guitar"
		],
		"filename": "1f3b8",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"musical_keyboard"
		],
		"filename": "1f3b9",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"trumpet"
		],
		"filename": "1f3ba",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"violin"
		],
		"filename": "1f3bb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"banjo"
		],
		"filename": "1fa95",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"drum"
		],
		"filename": "1f941",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"iphone"
		],
		"filename": "1f4f1",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"calling"
		],
		"filename": "1f4f2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"phone",
			"telephone"
		],
		"filename": "260e-fe0f",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"telephone_receiver"
		],
		"filename": "1f4de",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"pager"
		],
		"filename": "1f4df",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"fax"
		],
		"filename": "1f4e0",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"battery"
		],
		"filename": "1f50b",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"electric_plug"
		],
		"filename": "1f50c",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"computer"
		],
		"filename": "1f4bb",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"desktop_computer"
		],
		"filename": "1f5a5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"printer"
		],
		"filename": "1f5a8",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"keyboard"
		],
		"filename": "2328-fe0f",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"computer_mouse"
		],
		"filename": "1f5b1",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"trackball"
		],
		"filename": "1f5b2",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"minidisc"
		],
		"filename": "1f4bd",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"floppy_disk"
		],
		"filename": "1f4be",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"cd"
		],
		"filename": "1f4bf",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"dvd"
		],
		"filename": "1f4c0",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"abacus"
		],
		"filename": "1f9ee",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"movie_camera"
		],
		"filename": "1f3a5",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"film_strip"
		],
		"filename": "1f39e",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"film_projector"
		],
		"filename": "1f4fd",
		"category": "objects",
		"batch": "2"
	},
	{
		"aliases": [
			"clapper"
		],
		"filename": "1f3ac",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"tv"
		],
		"filename": "1f4fa",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"camera"
		],
		"filename": "1f4f7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"camera_flash"
		],
		"filename": "1f4f8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"video_camera"
		],
		"filename": "1f4f9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"vhs"
		],
		"filename": "1f4fc",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"mag"
		],
		"filename": "1f50d",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"mag_right"
		],
		"filename": "1f50e",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"candle"
		],
		"filename": "1f56f",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bulb"
		],
		"filename": "1f4a1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"flashlight"
		],
		"filename": "1f526",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"izakaya_lantern",
			"lantern"
		],
		"filename": "1f3ee",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"diya_lamp"
		],
		"filename": "1fa94",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"notebook_with_decorative_cover"
		],
		"filename": "1f4d4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"closed_book"
		],
		"filename": "1f4d5",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"book",
			"open_book"
		],
		"filename": "1f4d6",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"green_book"
		],
		"filename": "1f4d7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"blue_book"
		],
		"filename": "1f4d8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"orange_book"
		],
		"filename": "1f4d9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"books"
		],
		"filename": "1f4da",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"notebook"
		],
		"filename": "1f4d3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"ledger"
		],
		"filename": "1f4d2",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"page_with_curl"
		],
		"filename": "1f4c3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"scroll"
		],
		"filename": "1f4dc",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"page_facing_up"
		],
		"filename": "1f4c4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"newspaper"
		],
		"filename": "1f4f0",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"newspaper_roll"
		],
		"filename": "1f5de",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bookmark_tabs"
		],
		"filename": "1f4d1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"bookmark"
		],
		"filename": "1f516",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"label"
		],
		"filename": "1f3f7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"moneybag"
		],
		"filename": "1f4b0",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"yen"
		],
		"filename": "1f4b4",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"dollar"
		],
		"filename": "1f4b5",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"euro"
		],
		"filename": "1f4b6",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"pound"
		],
		"filename": "1f4b7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"money_with_wings"
		],
		"filename": "1f4b8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"credit_card"
		],
		"filename": "1f4b3",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"receipt"
		],
		"filename": "1f9fe",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"chart"
		],
		"filename": "1f4b9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"currency_exchange"
		],
		"filename": "1f4b1",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_dollar_sign"
		],
		"filename": "1f4b2",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"email",
			"envelope"
		],
		"filename": "2709-fe0f",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"e-mail"
		],
		"filename": "1f4e7",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"incoming_envelope"
		],
		"filename": "1f4e8",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"envelope_with_arrow"
		],
		"filename": "1f4e9",
		"category": "objects",
		"batch": "3"
	},
	{
		"aliases": [
			"outbox_tray"
		],
		"filename": "1f4e4",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"inbox_tray"
		],
		"filename": "1f4e5",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"package"
		],
		"filename": "1f4e6",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox"
		],
		"filename": "1f4eb",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_closed"
		],
		"filename": "1f4ea",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_with_mail"
		],
		"filename": "1f4ec",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"mailbox_with_no_mail"
		],
		"filename": "1f4ed",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"postbox"
		],
		"filename": "1f4ee",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"ballot_box"
		],
		"filename": "1f5f3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pencil2"
		],
		"filename": "270f-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"black_nib"
		],
		"filename": "2712-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"fountain_pen"
		],
		"filename": "1f58b",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pen"
		],
		"filename": "1f58a",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paintbrush"
		],
		"filename": "1f58c",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"crayon"
		],
		"filename": "1f58d",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"memo",
			"pencil"
		],
		"filename": "1f4dd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"briefcase"
		],
		"filename": "1f4bc",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"file_folder"
		],
		"filename": "1f4c1",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"open_file_folder"
		],
		"filename": "1f4c2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_index_dividers"
		],
		"filename": "1f5c2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"date"
		],
		"filename": "1f4c5",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"calendar"
		],
		"filename": "1f4c6",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"spiral_notepad"
		],
		"filename": "1f5d2",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"spiral_calendar"
		],
		"filename": "1f5d3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_index"
		],
		"filename": "1f4c7",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"chart_with_upwards_trend"
		],
		"filename": "1f4c8",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"chart_with_downwards_trend"
		],
		"filename": "1f4c9",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"bar_chart"
		],
		"filename": "1f4ca",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"clipboard"
		],
		"filename": "1f4cb",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"pushpin"
		],
		"filename": "1f4cc",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"round_pushpin"
		],
		"filename": "1f4cd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paperclip"
		],
		"filename": "1f4ce",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"paperclips"
		],
		"filename": "1f587",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"straight_ruler"
		],
		"filename": "1f4cf",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"triangular_ruler"
		],
		"filename": "1f4d0",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"scissors"
		],
		"filename": "2702-fe0f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"card_file_box"
		],
		"filename": "1f5c3",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"file_cabinet"
		],
		"filename": "1f5c4",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"wastebasket"
		],
		"filename": "1f5d1",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"lock"
		],
		"filename": "1f512",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"unlock"
		],
		"filename": "1f513",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"lock_with_ink_pen"
		],
		"filename": "1f50f",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"closed_lock_with_key"
		],
		"filename": "1f510",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"key"
		],
		"filename": "1f511",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"old_key"
		],
		"filename": "1f5dd",
		"category": "objects",
		"batch": "4"
	},
	{
		"aliases": [
			"hammer"
		],
		"filename": "1f528",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"axe"
		],
		"filename": "1fa93",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"pick"
		],
		"filename": "26cf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"hammer_and_pick"
		],
		"filename": "2692",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"hammer_and_wrench"
		],
		"filename": "1f6e0",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"dagger"
		],
		"filename": "1f5e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"crossed_swords"
		],
		"filename": "2694-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"gun"
		],
		"filename": "1f52b",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bow_and_arrow"
		],
		"filename": "1f3f9",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"shield"
		],
		"filename": "1f6e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"wrench"
		],
		"filename": "1f527",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"nut_and_bolt"
		],
		"filename": "1f529",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"gear"
		],
		"filename": "2699-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"clamp"
		],
		"filename": "1f5dc",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"balance_scale"
		],
		"filename": "2696-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"probing_cane"
		],
		"filename": "1f9af",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"link"
		],
		"filename": "1f517",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"chains"
		],
		"filename": "26d3",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"toolbox"
		],
		"filename": "1f9f0",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"magnet"
		],
		"filename": "1f9f2",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"alembic"
		],
		"filename": "2697-fe0f",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"test_tube"
		],
		"filename": "1f9ea",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"petri_dish"
		],
		"filename": "1f9eb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"dna"
		],
		"filename": "1f9ec",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"microscope"
		],
		"filename": "1f52c",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"telescope"
		],
		"filename": "1f52d",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"satellite"
		],
		"filename": "1f4e1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"syringe"
		],
		"filename": "1f489",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"drop_of_blood"
		],
		"filename": "1fa78",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"pill"
		],
		"filename": "1f48a",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"adhesive_bandage"
		],
		"filename": "1fa79",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"stethoscope"
		],
		"filename": "1fa7a",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"door"
		],
		"filename": "1f6aa",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bed"
		],
		"filename": "1f6cf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"couch_and_lamp"
		],
		"filename": "1f6cb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"chair"
		],
		"filename": "1fa91",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"toilet"
		],
		"filename": "1f6bd",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"shower"
		],
		"filename": "1f6bf",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"bathtub"
		],
		"filename": "1f6c1",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"razor"
		],
		"filename": "1fa92",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"lotion_bottle"
		],
		"filename": "1f9f4",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"safety_pin"
		],
		"filename": "1f9f7",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"broom"
		],
		"filename": "1f9f9",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"basket"
		],
		"filename": "1f9fa",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"roll_of_paper"
		],
		"filename": "1f9fb",
		"category": "objects",
		"batch": "5"
	},
	{
		"aliases": [
			"soap"
		],
		"filename": "1f9fc",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"sponge"
		],
		"filename": "1f9fd",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"fire_extinguisher"
		],
		"filename": "1f9ef",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"shopping_cart"
		],
		"filename": "1f6d2",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"smoking"
		],
		"filename": "1f6ac",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"coffin"
		],
		"filename": "26b0-fe0f",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"funeral_urn"
		],
		"filename": "26b1-fe0f",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"moyai"
		],
		"filename": "1f5ff",
		"category": "objects",
		"batch": "6"
	},
	{
		"aliases": [
			"atm"
		],
		"filename": "1f3e7",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"put_litter_in_its_place"
		],
		"filename": "1f6ae",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"potable_water"
		],
		"filename": "1f6b0",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"wheelchair"
		],
		"filename": "267f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"mens"
		],
		"filename": "1f6b9",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"womens"
		],
		"filename": "1f6ba",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"restroom"
		],
		"filename": "1f6bb",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"baby_symbol"
		],
		"filename": "1f6bc",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"wc"
		],
		"filename": "1f6be",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"passport_control"
		],
		"filename": "1f6c2",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"customs"
		],
		"filename": "1f6c3",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"baggage_claim"
		],
		"filename": "1f6c4",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"left_luggage"
		],
		"filename": "1f6c5",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"warning"
		],
		"filename": "26a0-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"children_crossing"
		],
		"filename": "1f6b8",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_entry"
		],
		"filename": "26d4",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_entry_sign"
		],
		"filename": "1f6ab",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_bicycles"
		],
		"filename": "1f6b3",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_smoking"
		],
		"filename": "1f6ad",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"do_not_litter"
		],
		"filename": "1f6af",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"non-potable_water"
		],
		"filename": "1f6b1",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_pedestrians"
		],
		"filename": "1f6b7",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"no_mobile_phones"
		],
		"filename": "1f4f5",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"underage"
		],
		"filename": "1f51e",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"radioactive"
		],
		"filename": "2622-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"biohazard"
		],
		"filename": "2623-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_up"
		],
		"filename": "2b06-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_upper_right"
		],
		"filename": "2197-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_right"
		],
		"filename": "27a1-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_lower_right"
		],
		"filename": "2198-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_down"
		],
		"filename": "2b07-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_lower_left"
		],
		"filename": "2199-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_left"
		],
		"filename": "2b05-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_upper_left"
		],
		"filename": "2196-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_up_down"
		],
		"filename": "2195-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"left_right_arrow"
		],
		"filename": "2194-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"leftwards_arrow_with_hook"
		],
		"filename": "21a9-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_right_hook"
		],
		"filename": "21aa-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_heading_up"
		],
		"filename": "2934-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrow_heading_down"
		],
		"filename": "2935-fe0f",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrows_clockwise"
		],
		"filename": "1f503",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"arrows_counterclockwise"
		],
		"filename": "1f504",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"back"
		],
		"filename": "1f519",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"end"
		],
		"filename": "1f51a",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"on"
		],
		"filename": "1f51b",
		"category": "symbols",
		"batch": "1"
	},
	{
		"aliases": [
			"soon"
		],
		"filename": "1f51c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"top"
		],
		"filename": "1f51d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"place_of_worship"
		],
		"filename": "1f6d0",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"atom_symbol"
		],
		"filename": "269b-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"om"
		],
		"filename": "1f549",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"star_of_david"
		],
		"filename": "2721-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"wheel_of_dharma"
		],
		"filename": "2638-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"yin_yang"
		],
		"filename": "262f-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"latin_cross"
		],
		"filename": "271d-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"orthodox_cross"
		],
		"filename": "2626-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"star_and_crescent"
		],
		"filename": "262a-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"peace_symbol"
		],
		"filename": "262e-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"menorah"
		],
		"filename": "1f54e",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"six_pointed_star"
		],
		"filename": "1f52f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"aries"
		],
		"filename": "2648",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"taurus"
		],
		"filename": "2649",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"gemini"
		],
		"filename": "264a",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"cancer"
		],
		"filename": "264b",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"leo"
		],
		"filename": "264c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"virgo"
		],
		"filename": "264d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"libra"
		],
		"filename": "264e",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"scorpius"
		],
		"filename": "264f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"sagittarius"
		],
		"filename": "2650",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"capricorn"
		],
		"filename": "2651",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"aquarius"
		],
		"filename": "2652",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"pisces"
		],
		"filename": "2653",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"ophiuchus"
		],
		"filename": "26ce",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"twisted_rightwards_arrows"
		],
		"filename": "1f500",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"repeat"
		],
		"filename": "1f501",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"repeat_one"
		],
		"filename": "1f502",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_forward"
		],
		"filename": "25b6-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"fast_forward"
		],
		"filename": "23e9",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"next_track_button"
		],
		"filename": "23ed",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"play_or_pause_button"
		],
		"filename": "23ef",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_backward"
		],
		"filename": "25c0-fe0f",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"rewind"
		],
		"filename": "23ea",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"previous_track_button"
		],
		"filename": "23ee",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_up_small"
		],
		"filename": "1f53c",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_double_up"
		],
		"filename": "23eb",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_down_small"
		],
		"filename": "1f53d",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"arrow_double_down"
		],
		"filename": "23ec",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"pause_button"
		],
		"filename": "23f8",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"stop_button"
		],
		"filename": "23f9",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"record_button"
		],
		"filename": "23fa",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"eject_button"
		],
		"filename": "23cf",
		"category": "symbols",
		"batch": "2"
	},
	{
		"aliases": [
			"cinema"
		],
		"filename": "1f3a6",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"low_brightness"
		],
		"filename": "1f505",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"high_brightness"
		],
		"filename": "1f506",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"signal_strength"
		],
		"filename": "1f4f6",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"vibration_mode"
		],
		"filename": "1f4f3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"mobile_phone_off"
		],
		"filename": "1f4f4",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"female_sign"
		],
		"filename": "2640",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"male_sign"
		],
		"filename": "2642",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"medical_symbol"
		],
		"filename": "2695",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"infinity"
		],
		"filename": "267e",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"recycle"
		],
		"filename": "267b-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"fleur_de_lis"
		],
		"filename": "269c-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"trident"
		],
		"filename": "1f531",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"name_badge"
		],
		"filename": "1f4db",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"beginner"
		],
		"filename": "1f530",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"o"
		],
		"filename": "2b55",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"white_check_mark"
		],
		"filename": "2705",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"ballot_box_with_check"
		],
		"filename": "2611-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_check_mark"
		],
		"filename": "2714-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_multiplication_x"
		],
		"filename": "2716-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"x"
		],
		"filename": "274c",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"negative_squared_cross_mark"
		],
		"filename": "274e",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_plus_sign"
		],
		"filename": "2795",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_minus_sign"
		],
		"filename": "2796",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"heavy_division_sign"
		],
		"filename": "2797",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"curly_loop"
		],
		"filename": "27b0",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"loop"
		],
		"filename": "27bf",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"part_alternation_mark"
		],
		"filename": "303d-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"eight_spoked_asterisk"
		],
		"filename": "2733-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"eight_pointed_black_star"
		],
		"filename": "2734-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"sparkle"
		],
		"filename": "2747-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"bangbang"
		],
		"filename": "203c-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"interrobang"
		],
		"filename": "2049-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"question"
		],
		"filename": "2753",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"grey_question"
		],
		"filename": "2754",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"grey_exclamation"
		],
		"filename": "2755",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"exclamation",
			"heavy_exclamation_mark"
		],
		"filename": "2757",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"wavy_dash"
		],
		"filename": "3030-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"copyright"
		],
		"filename": "00a9-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"registered"
		],
		"filename": "00ae-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"tm"
		],
		"filename": "2122-fe0f",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"hash"
		],
		"filename": "0023-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"asterisk"
		],
		"filename": "002a-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"zero"
		],
		"filename": "0030-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"one"
		],
		"filename": "0031-fe0f-20e3",
		"category": "symbols",
		"batch": "3"
	},
	{
		"aliases": [
			"two"
		],
		"filename": "0032-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"three"
		],
		"filename": "0033-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"four"
		],
		"filename": "0034-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"five"
		],
		"filename": "0035-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"six"
		],
		"filename": "0036-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"seven"
		],
		"filename": "0037-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"eight"
		],
		"filename": "0038-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"nine"
		],
		"filename": "0039-fe0f-20e3",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"keycap_ten"
		],
		"filename": "1f51f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"capital_abcd"
		],
		"filename": "1f520",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"abcd"
		],
		"filename": "1f521",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"1234"
		],
		"filename": "1f522",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"symbols"
		],
		"filename": "1f523",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"abc"
		],
		"filename": "1f524",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"a"
		],
		"filename": "1f170-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ab"
		],
		"filename": "1f18e",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"b"
		],
		"filename": "1f171-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"cl"
		],
		"filename": "1f191",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"cool"
		],
		"filename": "1f192",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"free"
		],
		"filename": "1f193",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"information_source"
		],
		"filename": "2139-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"id"
		],
		"filename": "1f194",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"m"
		],
		"filename": "24c2-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"new"
		],
		"filename": "1f195",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ng"
		],
		"filename": "1f196",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"o2"
		],
		"filename": "1f17e-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ok"
		],
		"filename": "1f197",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"parking"
		],
		"filename": "1f17f-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"sos"
		],
		"filename": "1f198",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"up"
		],
		"filename": "1f199",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"vs"
		],
		"filename": "1f19a",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"koko"
		],
		"filename": "1f201",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"sa"
		],
		"filename": "1f202-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6708"
		],
		"filename": "1f237-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6709"
		],
		"filename": "1f236",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u6307"
		],
		"filename": "1f22f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"ideograph_advantage"
		],
		"filename": "1f250",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u5272"
		],
		"filename": "1f239",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7121"
		],
		"filename": "1f21a",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7981"
		],
		"filename": "1f232",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"accept"
		],
		"filename": "1f251",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7533"
		],
		"filename": "1f238",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u5408"
		],
		"filename": "1f234",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"u7a7a"
		],
		"filename": "1f233",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"congratulations"
		],
		"filename": "3297-fe0f",
		"category": "symbols",
		"batch": "4"
	},
	{
		"aliases": [
			"secret"
		],
		"filename": "3299-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"u55b6"
		],
		"filename": "1f23a",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"u6e80"
		],
		"filename": "1f235",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"red_circle"
		],
		"filename": "1f534",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"orange_circle"
		],
		"filename": "1f7e0",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"yellow_circle"
		],
		"filename": "1f7e1",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"green_circle"
		],
		"filename": "1f7e2",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_blue_circle"
		],
		"filename": "1f535",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"purple_circle"
		],
		"filename": "1f7e3",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"brown_circle"
		],
		"filename": "1f7e4",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_circle"
		],
		"filename": "26ab",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_circle"
		],
		"filename": "26aa",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"red_square"
		],
		"filename": "1f7e5",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"orange_square"
		],
		"filename": "1f7e7",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"yellow_square"
		],
		"filename": "1f7e8",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"green_square"
		],
		"filename": "1f7e9",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"blue_square"
		],
		"filename": "1f7e6",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"purple_square"
		],
		"filename": "1f7ea",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"brown_square"
		],
		"filename": "1f7eb",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_large_square"
		],
		"filename": "2b1b",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_large_square"
		],
		"filename": "2b1c",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_medium_square"
		],
		"filename": "25fc-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_medium_square"
		],
		"filename": "25fb-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_medium_small_square"
		],
		"filename": "25fe",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_medium_small_square"
		],
		"filename": "25fd",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_small_square"
		],
		"filename": "25aa-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_small_square"
		],
		"filename": "25ab-fe0f",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_orange_diamond"
		],
		"filename": "1f536",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"large_blue_diamond"
		],
		"filename": "1f537",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_orange_diamond"
		],
		"filename": "1f538",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_blue_diamond"
		],
		"filename": "1f539",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_red_triangle"
		],
		"filename": "1f53a",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"small_red_triangle_down"
		],
		"filename": "1f53b",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"diamond_shape_with_a_dot_inside"
		],
		"filename": "1f4a0",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"radio_button"
		],
		"filename": "1f518",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"white_square_button"
		],
		"filename": "1f533",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"black_square_button"
		],
		"filename": "1f532",
		"category": "symbols",
		"batch": "5"
	},
	{
		"aliases": [
			"checkered_flag"
		],
		"filename": "1f3c1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"triangular_flag_on_post"
		],
		"filename": "1f6a9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_flags"
		],
		"filename": "1f38c",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"black_flag"
		],
		"filename": "1f3f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"white_flag"
		],
		"filename": "1f3f3-fe0f",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"rainbow_flag"
		],
		"filename": "1f3f3-fe0f-200d-1f308",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"pirate_flag"
		],
		"filename": "1f3f4-200d-2620-fe0f",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"ascension_island"
		],
		"filename": "1f1e6-1f1e8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"andorra"
		],
		"filename": "1f1e6-1f1e9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"united_arab_emirates"
		],
		"filename": "1f1e6-1f1ea",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"afghanistan"
		],
		"filename": "1f1e6-1f1eb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"antigua_barbuda"
		],
		"filename": "1f1e6-1f1ec",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"anguilla"
		],
		"filename": "1f1e6-1f1ee",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"albania"
		],
		"filename": "1f1e6-1f1f1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"armenia"
		],
		"filename": "1f1e6-1f1f2",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"angola"
		],
		"filename": "1f1e6-1f1f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"antarctica"
		],
		"filename": "1f1e6-1f1f6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"argentina"
		],
		"filename": "1f1e6-1f1f7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"american_samoa"
		],
		"filename": "1f1e6-1f1f8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"austria"
		],
		"filename": "1f1e6-1f1f9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"australia"
		],
		"filename": "1f1e6-1f1fa",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"aruba"
		],
		"filename": "1f1e6-1f1fc",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"aland_islands"
		],
		"filename": "1f1e6-1f1fd",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"azerbaijan"
		],
		"filename": "1f1e6-1f1ff",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bosnia_herzegovina"
		],
		"filename": "1f1e7-1f1e6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"barbados"
		],
		"filename": "1f1e7-1f1e7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bangladesh"
		],
		"filename": "1f1e7-1f1e9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belgium"
		],
		"filename": "1f1e7-1f1ea",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"burkina_faso"
		],
		"filename": "1f1e7-1f1eb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bulgaria"
		],
		"filename": "1f1e7-1f1ec",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bahrain"
		],
		"filename": "1f1e7-1f1ed",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"burundi"
		],
		"filename": "1f1e7-1f1ee",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"benin"
		],
		"filename": "1f1e7-1f1ef",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"st_barthelemy"
		],
		"filename": "1f1e7-1f1f1",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bermuda"
		],
		"filename": "1f1e7-1f1f2",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"brunei"
		],
		"filename": "1f1e7-1f1f3",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bolivia"
		],
		"filename": "1f1e7-1f1f4",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"caribbean_netherlands"
		],
		"filename": "1f1e7-1f1f6",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"brazil"
		],
		"filename": "1f1e7-1f1f7",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bahamas"
		],
		"filename": "1f1e7-1f1f8",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bhutan"
		],
		"filename": "1f1e7-1f1f9",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"bouvet_island"
		],
		"filename": "1f1e7-1f1fb",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"botswana"
		],
		"filename": "1f1e7-1f1fc",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belarus"
		],
		"filename": "1f1e7-1f1fe",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"belize"
		],
		"filename": "1f1e7-1f1ff",
		"category": "flags",
		"batch": "1"
	},
	{
		"aliases": [
			"canada",
			"ca"
		],
		"filename": "1f1e8-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cocos_islands"
		],
		"filename": "1f1e8-1f1e8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"congo_kinshasa"
		],
		"filename": "1f1e8-1f1e9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"central_african_republic"
		],
		"filename": "1f1e8-1f1eb",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"congo_brazzaville"
		],
		"filename": "1f1e8-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"switzerland"
		],
		"filename": "1f1e8-1f1ed",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cote_divoire"
		],
		"filename": "1f1e8-1f1ee",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cook_islands"
		],
		"filename": "1f1e8-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"chile"
		],
		"filename": "1f1e8-1f1f1",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cameroon"
		],
		"filename": "1f1e8-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cn"
		],
		"filename": "1f1e8-1f1f3",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"colombia"
		],
		"filename": "1f1e8-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"clipperton_island"
		],
		"filename": "1f1e8-1f1f5",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"costa_rica"
		],
		"filename": "1f1e8-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cuba"
		],
		"filename": "1f1e8-1f1fa",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cape_verde"
		],
		"filename": "1f1e8-1f1fb",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"curacao"
		],
		"filename": "1f1e8-1f1fc",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"christmas_island"
		],
		"filename": "1f1e8-1f1fd",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"cyprus"
		],
		"filename": "1f1e8-1f1fe",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"czech_republic"
		],
		"filename": "1f1e8-1f1ff",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"de"
		],
		"filename": "1f1e9-1f1ea",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"diego_garcia"
		],
		"filename": "1f1e9-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"djibouti"
		],
		"filename": "1f1e9-1f1ef",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"denmark"
		],
		"filename": "1f1e9-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"dominica"
		],
		"filename": "1f1e9-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"dominican_republic"
		],
		"filename": "1f1e9-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"algeria"
		],
		"filename": "1f1e9-1f1ff",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ceuta_melilla"
		],
		"filename": "1f1ea-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ecuador"
		],
		"filename": "1f1ea-1f1e8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"estonia"
		],
		"filename": "1f1ea-1f1ea",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"egypt"
		],
		"filename": "1f1ea-1f1ec",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"western_sahara"
		],
		"filename": "1f1ea-1f1ed",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"eritrea"
		],
		"filename": "1f1ea-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"es"
		],
		"filename": "1f1ea-1f1f8",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"ethiopia"
		],
		"filename": "1f1ea-1f1f9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"eu",
			"european_union"
		],
		"filename": "1f1ea-1f1fa",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"finland"
		],
		"filename": "1f1eb-1f1ee",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"fiji"
		],
		"filename": "1f1eb-1f1ef",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"falkland_islands"
		],
		"filename": "1f1eb-1f1f0",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"micronesia"
		],
		"filename": "1f1eb-1f1f2",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"faroe_islands"
		],
		"filename": "1f1eb-1f1f4",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"fr"
		],
		"filename": "1f1eb-1f1f7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"gabon"
		],
		"filename": "1f1ec-1f1e6",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"gb",
			"uk"
		],
		"filename": "1f1ec-1f1e7",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"grenada"
		],
		"filename": "1f1ec-1f1e9",
		"category": "flags",
		"batch": "2"
	},
	{
		"aliases": [
			"georgia"
		],
		"filename": "1f1ec-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"french_guiana"
		],
		"filename": "1f1ec-1f1eb",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guernsey"
		],
		"filename": "1f1ec-1f1ec",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"ghana"
		],
		"filename": "1f1ec-1f1ed",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"gibraltar"
		],
		"filename": "1f1ec-1f1ee",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"greenland"
		],
		"filename": "1f1ec-1f1f1",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"gambia"
		],
		"filename": "1f1ec-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guinea"
		],
		"filename": "1f1ec-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guadeloupe"
		],
		"filename": "1f1ec-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"equatorial_guinea"
		],
		"filename": "1f1ec-1f1f6",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"greece"
		],
		"filename": "1f1ec-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"south_georgia_south_sandwich_islands"
		],
		"filename": "1f1ec-1f1f8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guatemala"
		],
		"filename": "1f1ec-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guam"
		],
		"filename": "1f1ec-1f1fa",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guinea_bissau"
		],
		"filename": "1f1ec-1f1fc",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"guyana"
		],
		"filename": "1f1ec-1f1fe",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"hong_kong"
		],
		"filename": "1f1ed-1f1f0",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"heard_mcdonald_islands"
		],
		"filename": "1f1ed-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"honduras"
		],
		"filename": "1f1ed-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"croatia"
		],
		"filename": "1f1ed-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"haiti"
		],
		"filename": "1f1ed-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"hungary"
		],
		"filename": "1f1ed-1f1fa",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"canary_islands"
		],
		"filename": "1f1ee-1f1e8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"indonesia"
		],
		"filename": "1f1ee-1f1e9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"ireland"
		],
		"filename": "1f1ee-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"israel"
		],
		"filename": "1f1ee-1f1f1",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"isle_of_man"
		],
		"filename": "1f1ee-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"india"
		],
		"filename": "1f1ee-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"british_indian_ocean_territory"
		],
		"filename": "1f1ee-1f1f4",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iraq"
		],
		"filename": "1f1ee-1f1f6",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iran"
		],
		"filename": "1f1ee-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"iceland"
		],
		"filename": "1f1ee-1f1f8",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"it"
		],
		"filename": "1f1ee-1f1f9",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jersey"
		],
		"filename": "1f1ef-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jamaica"
		],
		"filename": "1f1ef-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jordan"
		],
		"filename": "1f1ef-1f1f4",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"jp"
		],
		"filename": "1f1ef-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kenya"
		],
		"filename": "1f1f0-1f1ea",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kyrgyzstan"
		],
		"filename": "1f1f0-1f1ec",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"cambodia"
		],
		"filename": "1f1f0-1f1ed",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kiribati"
		],
		"filename": "1f1f0-1f1ee",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"comoros"
		],
		"filename": "1f1f0-1f1f2",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"st_kitts_nevis"
		],
		"filename": "1f1f0-1f1f3",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"north_korea"
		],
		"filename": "1f1f0-1f1f5",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kr"
		],
		"filename": "1f1f0-1f1f7",
		"category": "flags",
		"batch": "3"
	},
	{
		"aliases": [
			"kuwait"
		],
		"filename": "1f1f0-1f1fc",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"cayman_islands"
		],
		"filename": "1f1f0-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"kazakhstan"
		],
		"filename": "1f1f0-1f1ff",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"laos"
		],
		"filename": "1f1f1-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lebanon"
		],
		"filename": "1f1f1-1f1e7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"st_lucia"
		],
		"filename": "1f1f1-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"liechtenstein"
		],
		"filename": "1f1f1-1f1ee",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"sri_lanka"
		],
		"filename": "1f1f1-1f1f0",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"liberia"
		],
		"filename": "1f1f1-1f1f7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lesotho"
		],
		"filename": "1f1f1-1f1f8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"lithuania"
		],
		"filename": "1f1f1-1f1f9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"luxembourg"
		],
		"filename": "1f1f1-1f1fa",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"latvia"
		],
		"filename": "1f1f1-1f1fb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"libya"
		],
		"filename": "1f1f1-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"morocco"
		],
		"filename": "1f1f2-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"monaco"
		],
		"filename": "1f1f2-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"moldova"
		],
		"filename": "1f1f2-1f1e9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"montenegro"
		],
		"filename": "1f1f2-1f1ea",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"st_martin"
		],
		"filename": "1f1f2-1f1eb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"madagascar"
		],
		"filename": "1f1f2-1f1ec",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"marshall_islands"
		],
		"filename": "1f1f2-1f1ed",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"macedonia"
		],
		"filename": "1f1f2-1f1f0",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mali"
		],
		"filename": "1f1f2-1f1f1",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"myanmar"
		],
		"filename": "1f1f2-1f1f2",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mongolia"
		],
		"filename": "1f1f2-1f1f3",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"macau"
		],
		"filename": "1f1f2-1f1f4",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"northern_mariana_islands"
		],
		"filename": "1f1f2-1f1f5",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"martinique"
		],
		"filename": "1f1f2-1f1f6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mauritania"
		],
		"filename": "1f1f2-1f1f7",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"montserrat"
		],
		"filename": "1f1f2-1f1f8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malta"
		],
		"filename": "1f1f2-1f1f9",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mauritius"
		],
		"filename": "1f1f2-1f1fa",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"maldives"
		],
		"filename": "1f1f2-1f1fb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malawi"
		],
		"filename": "1f1f2-1f1fc",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mexico"
		],
		"filename": "1f1f2-1f1fd",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"malaysia"
		],
		"filename": "1f1f2-1f1fe",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"mozambique"
		],
		"filename": "1f1f2-1f1ff",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"namibia"
		],
		"filename": "1f1f3-1f1e6",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"new_caledonia"
		],
		"filename": "1f1f3-1f1e8",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"niger"
		],
		"filename": "1f1f3-1f1ea",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"norfolk_island"
		],
		"filename": "1f1f3-1f1eb",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nigeria"
		],
		"filename": "1f1f3-1f1ec",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nicaragua"
		],
		"filename": "1f1f3-1f1ee",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"netherlands"
		],
		"filename": "1f1f3-1f1f1",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"norway"
		],
		"filename": "1f1f3-1f1f4",
		"category": "flags",
		"batch": "4"
	},
	{
		"aliases": [
			"nepal"
		],
		"filename": "1f1f3-1f1f5",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"nauru"
		],
		"filename": "1f1f3-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"niue"
		],
		"filename": "1f1f3-1f1fa",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"new_zealand"
		],
		"filename": "1f1f3-1f1ff",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"oman"
		],
		"filename": "1f1f4-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"panama"
		],
		"filename": "1f1f5-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"peru"
		],
		"filename": "1f1f5-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"french_polynesia"
		],
		"filename": "1f1f5-1f1eb",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"papua_new_guinea"
		],
		"filename": "1f1f5-1f1ec",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"philippines"
		],
		"filename": "1f1f5-1f1ed",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"pakistan",
			"pk"
		],
		"filename": "1f1f5-1f1f0",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"poland"
		],
		"filename": "1f1f5-1f1f1",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"st_pierre_miquelon"
		],
		"filename": "1f1f5-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"pitcairn_islands"
		],
		"filename": "1f1f5-1f1f3",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"puerto_rico"
		],
		"filename": "1f1f5-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"palestinian_territories"
		],
		"filename": "1f1f5-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"portugal"
		],
		"filename": "1f1f5-1f1f9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"palau"
		],
		"filename": "1f1f5-1f1fc",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"paraguay"
		],
		"filename": "1f1f5-1f1fe",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"qatar"
		],
		"filename": "1f1f6-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"reunion"
		],
		"filename": "1f1f7-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"romania"
		],
		"filename": "1f1f7-1f1f4",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"serbia"
		],
		"filename": "1f1f7-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"ru"
		],
		"filename": "1f1f7-1f1fa",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"rwanda"
		],
		"filename": "1f1f7-1f1fc",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"saudi_arabia"
		],
		"filename": "1f1f8-1f1e6",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"solomon_islands"
		],
		"filename": "1f1f8-1f1e7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"seychelles"
		],
		"filename": "1f1f8-1f1e8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sudan"
		],
		"filename": "1f1f8-1f1e9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sweden"
		],
		"filename": "1f1f8-1f1ea",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"singapore"
		],
		"filename": "1f1f8-1f1ec",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"st_helena"
		],
		"filename": "1f1f8-1f1ed",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"slovenia"
		],
		"filename": "1f1f8-1f1ee",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"svalbard_jan_mayen"
		],
		"filename": "1f1f8-1f1ef",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"slovakia"
		],
		"filename": "1f1f8-1f1f0",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sierra_leone"
		],
		"filename": "1f1f8-1f1f1",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"san_marino"
		],
		"filename": "1f1f8-1f1f2",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"senegal"
		],
		"filename": "1f1f8-1f1f3",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"somalia"
		],
		"filename": "1f1f8-1f1f4",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"suriname"
		],
		"filename": "1f1f8-1f1f7",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"south_sudan"
		],
		"filename": "1f1f8-1f1f8",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sao_tome_principe"
		],
		"filename": "1f1f8-1f1f9",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"el_salvador"
		],
		"filename": "1f1f8-1f1fb",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"sint_maarten"
		],
		"filename": "1f1f8-1f1fd",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"syria"
		],
		"filename": "1f1f8-1f1fe",
		"category": "flags",
		"batch": "5"
	},
	{
		"aliases": [
			"swaziland"
		],
		"filename": "1f1f8-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tristan_da_cunha"
		],
		"filename": "1f1f9-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"turks_caicos_islands"
		],
		"filename": "1f1f9-1f1e8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"chad"
		],
		"filename": "1f1f9-1f1e9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"french_southern_territories"
		],
		"filename": "1f1f9-1f1eb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"togo"
		],
		"filename": "1f1f9-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"thailand"
		],
		"filename": "1f1f9-1f1ed",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tajikistan"
		],
		"filename": "1f1f9-1f1ef",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tokelau"
		],
		"filename": "1f1f9-1f1f0",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"timor_leste"
		],
		"filename": "1f1f9-1f1f1",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"turkmenistan"
		],
		"filename": "1f1f9-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tunisia"
		],
		"filename": "1f1f9-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tonga"
		],
		"filename": "1f1f9-1f1f4",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tr"
		],
		"filename": "1f1f9-1f1f7",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"trinidad_tobago"
		],
		"filename": "1f1f9-1f1f9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tuvalu"
		],
		"filename": "1f1f9-1f1fb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"taiwan"
		],
		"filename": "1f1f9-1f1fc",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"tanzania"
		],
		"filename": "1f1f9-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"ukraine"
		],
		"filename": "1f1fa-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uganda"
		],
		"filename": "1f1fa-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us_outlying_islands"
		],
		"filename": "1f1fa-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"united_nations"
		],
		"filename": "1f1fa-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us"
		],
		"filename": "1f1fa-1f1f8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uruguay"
		],
		"filename": "1f1fa-1f1fe",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"uzbekistan"
		],
		"filename": "1f1fa-1f1ff",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vatican_city"
		],
		"filename": "1f1fb-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"st_vincent_grenadines"
		],
		"filename": "1f1fb-1f1e8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"venezuela"
		],
		"filename": "1f1fb-1f1ea",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"british_virgin_islands"
		],
		"filename": "1f1fb-1f1ec",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"us_virgin_islands"
		],
		"filename": "1f1fb-1f1ee",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vietnam"
		],
		"filename": "1f1fb-1f1f3",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"vanuatu"
		],
		"filename": "1f1fb-1f1fa",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"wallis_futuna"
		],
		"filename": "1f1fc-1f1eb",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"samoa"
		],
		"filename": "1f1fc-1f1f8",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"kosovo"
		],
		"filename": "1f1fd-1f1f0",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"yemen"
		],
		"filename": "1f1fe-1f1ea",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"mayotte"
		],
		"filename": "1f1fe-1f1f9",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"south_africa",
			"za"
		],
		"filename": "1f1ff-1f1e6",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"zambia"
		],
		"filename": "1f1ff-1f1f2",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"zimbabwe"
		],
		"filename": "1f1ff-1f1fc",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"england"
		],
		"filename": "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"scotland"
		],
		"filename": "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"wales"
		],
		"filename": "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
		"category": "flags",
		"batch": "6"
	},
	{
		"aliases": [
			"cordchat"
		],
		"filename": "cordchat",
		"category": "custom",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_light_skin_tone"
		],
		"filename": "1f44b-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_light_skin_tone"
		],
		"filename": "1f44b-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_skin_tone"
		],
		"filename": "1f44b-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_medium_dark_skin_tone"
		],
		"filename": "1f44b-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"wave_dark_skin_tone"
		],
		"filename": "1f44b-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_light_skin_tone"
		],
		"filename": "1f91a-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_light_skin_tone"
		],
		"filename": "1f91a-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_skin_tone"
		],
		"filename": "1f91a-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_medium_dark_skin_tone"
		],
		"filename": "1f91a-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_back_of_hand_dark_skin_tone"
		],
		"filename": "1f91a-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_light_skin_tone"
		],
		"filename": "1f590-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_light_skin_tone"
		],
		"filename": "1f590-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_skin_tone"
		],
		"filename": "1f590-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_medium_dark_skin_tone"
		],
		"filename": "1f590-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"raised_hand_with_fingers_splayed_dark_skin_tone"
		],
		"filename": "1f590-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_light_skin_tone"
		],
		"filename": "270b-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_light_skin_tone"
		],
		"filename": "270b-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_skin_tone"
		],
		"filename": "270b-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_medium_dark_skin_tone"
		],
		"filename": "270b-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"hand_dark_skin_tone"
		],
		"filename": "270b-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_light_skin_tone"
		],
		"filename": "1f596-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_light_skin_tone"
		],
		"filename": "1f596-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_skin_tone"
		],
		"filename": "1f596-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_medium_dark_skin_tone"
		],
		"filename": "1f596-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"vulcan_salute_dark_skin_tone"
		],
		"filename": "1f596-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_light_skin_tone"
		],
		"filename": "1f44c-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_light_skin_tone"
		],
		"filename": "1f44c-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_skin_tone"
		],
		"filename": "1f44c-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_medium_dark_skin_tone"
		],
		"filename": "1f44c-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ok_hand_dark_skin_tone"
		],
		"filename": "1f44c-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_light_skin_tone"
		],
		"filename": "1f90f-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_light_skin_tone"
		],
		"filename": "1f90f-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_skin_tone"
		],
		"filename": "1f90f-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_medium_dark_skin_tone"
		],
		"filename": "1f90f-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"pinching_dark_skin_tone"
		],
		"filename": "1f90f-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_light_skin_tone"
		],
		"filename": "270c-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_light_skin_tone"
		],
		"filename": "270c-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_skin_tone"
		],
		"filename": "270c-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_medium_dark_skin_tone"
		],
		"filename": "270c-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"v_dark_skin_tone"
		],
		"filename": "270c-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_light_skin_tone"
		],
		"filename": "1f91e-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_light_skin_tone"
		],
		"filename": "1f91e-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_skin_tone"
		],
		"filename": "1f91e-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_medium_dark_skin_tone"
		],
		"filename": "1f91e-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"crossed_fingers_dark_skin_tone"
		],
		"filename": "1f91e-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_light_skin_tone"
		],
		"filename": "1f91f-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_light_skin_tone"
		],
		"filename": "1f91f-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_skin_tone"
		],
		"filename": "1f91f-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_medium_dark_skin_tone"
		],
		"filename": "1f91f-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"love_you_gesture_dark_skin_tone"
		],
		"filename": "1f91f-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"metal_light_skin_tone"
		],
		"filename": "1f918-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_light_skin_tone"
		],
		"filename": "1f918-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_skin_tone"
		],
		"filename": "1f918-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_medium_dark_skin_tone"
		],
		"filename": "1f918-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"metal_dark_skin_tone"
		],
		"filename": "1f918-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_light_skin_tone"
		],
		"filename": "1f919-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_light_skin_tone"
		],
		"filename": "1f919-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_skin_tone"
		],
		"filename": "1f919-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_medium_dark_skin_tone"
		],
		"filename": "1f919-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"call_me_hand_dark_skin_tone"
		],
		"filename": "1f919-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_light_skin_tone"
		],
		"filename": "1f448-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_light_skin_tone"
		],
		"filename": "1f448-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_skin_tone"
		],
		"filename": "1f448-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_medium_dark_skin_tone"
		],
		"filename": "1f448-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_left_dark_skin_tone"
		],
		"filename": "1f448-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_light_skin_tone"
		],
		"filename": "1f449-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_light_skin_tone"
		],
		"filename": "1f449-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_skin_tone"
		],
		"filename": "1f449-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_medium_dark_skin_tone"
		],
		"filename": "1f449-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_right_dark_skin_tone"
		],
		"filename": "1f449-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_light_skin_tone"
		],
		"filename": "1f446-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_light_skin_tone"
		],
		"filename": "1f446-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_skin_tone"
		],
		"filename": "1f446-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_medium_dark_skin_tone"
		],
		"filename": "1f446-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_2_dark_skin_tone"
		],
		"filename": "1f446-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_light_skin_tone"
		],
		"filename": "1f595-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_light_skin_tone"
		],
		"filename": "1f595-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_skin_tone"
		],
		"filename": "1f595-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_medium_dark_skin_tone"
		],
		"filename": "1f595-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"middle_finger_dark_skin_tone"
		],
		"filename": "1f595-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_light_skin_tone"
		],
		"filename": "1f447-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_light_skin_tone"
		],
		"filename": "1f447-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_skin_tone"
		],
		"filename": "1f447-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_medium_dark_skin_tone"
		],
		"filename": "1f447-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_down_dark_skin_tone"
		],
		"filename": "1f447-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_light_skin_tone"
		],
		"filename": "261d-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_light_skin_tone"
		],
		"filename": "261d-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_skin_tone"
		],
		"filename": "261d-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_medium_dark_skin_tone"
		],
		"filename": "261d-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"point_up_dark_skin_tone"
		],
		"filename": "261d-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_light_skin_tone"
		],
		"filename": "1f44d-1f3fb",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_light_skin_tone"
		],
		"filename": "1f44d-1f3fc",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_skin_tone"
		],
		"filename": "1f44d-1f3fd",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_medium_dark_skin_tone"
		],
		"filename": "1f44d-1f3fe",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"+1_dark_skin_tone"
		],
		"filename": "1f44d-1f3ff",
		"category": "skintone",
		"batch": "2"
	},
	{
		"aliases": [
			"-1_light_skin_tone"
		],
		"filename": "1f44e-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_light_skin_tone"
		],
		"filename": "1f44e-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_skin_tone"
		],
		"filename": "1f44e-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_medium_dark_skin_tone"
		],
		"filename": "1f44e-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"-1_dark_skin_tone"
		],
		"filename": "1f44e-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_light_skin_tone"
		],
		"filename": "270a-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_light_skin_tone"
		],
		"filename": "270a-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_skin_tone"
		],
		"filename": "270a-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_medium_dark_skin_tone"
		],
		"filename": "270a-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_raised_dark_skin_tone"
		],
		"filename": "270a-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_light_skin_tone"
		],
		"filename": "1f44a-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_light_skin_tone"
		],
		"filename": "1f44a-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_skin_tone"
		],
		"filename": "1f44a-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_medium_dark_skin_tone"
		],
		"filename": "1f44a-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_oncoming_dark_skin_tone"
		],
		"filename": "1f44a-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_light_skin_tone"
		],
		"filename": "1f91b-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_light_skin_tone"
		],
		"filename": "1f91b-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_skin_tone"
		],
		"filename": "1f91b-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_medium_dark_skin_tone"
		],
		"filename": "1f91b-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_left_dark_skin_tone"
		],
		"filename": "1f91b-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_light_skin_tone"
		],
		"filename": "1f91c-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_light_skin_tone"
		],
		"filename": "1f91c-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_skin_tone"
		],
		"filename": "1f91c-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_medium_dark_skin_tone"
		],
		"filename": "1f91c-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"fist_right_dark_skin_tone"
		],
		"filename": "1f91c-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_light_skin_tone"
		],
		"filename": "1f44f-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_light_skin_tone"
		],
		"filename": "1f44f-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_skin_tone"
		],
		"filename": "1f44f-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_medium_dark_skin_tone"
		],
		"filename": "1f44f-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"clap_dark_skin_tone"
		],
		"filename": "1f44f-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_light_skin_tone"
		],
		"filename": "1f64c-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_light_skin_tone"
		],
		"filename": "1f64c-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_skin_tone"
		],
		"filename": "1f64c-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_medium_dark_skin_tone"
		],
		"filename": "1f64c-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"raised_hands_dark_skin_tone"
		],
		"filename": "1f64c-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_light_skin_tone"
		],
		"filename": "1f450-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_light_skin_tone"
		],
		"filename": "1f450-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_skin_tone"
		],
		"filename": "1f450-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_medium_dark_skin_tone"
		],
		"filename": "1f450-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"open_hands_dark_skin_tone"
		],
		"filename": "1f450-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_light_skin_tone"
		],
		"filename": "1f932-1f3fb",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_light_skin_tone"
		],
		"filename": "1f932-1f3fc",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_skin_tone"
		],
		"filename": "1f932-1f3fd",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_medium_dark_skin_tone"
		],
		"filename": "1f932-1f3fe",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"palms_up_together_dark_skin_tone"
		],
		"filename": "1f932-1f3ff",
		"category": "skintone",
		"batch": "3"
	},
	{
		"aliases": [
			"pray_light_skin_tone"
		],
		"filename": "1f64f-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_light_skin_tone"
		],
		"filename": "1f64f-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_skin_tone"
		],
		"filename": "1f64f-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_medium_dark_skin_tone"
		],
		"filename": "1f64f-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"pray_dark_skin_tone"
		],
		"filename": "1f64f-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_light_skin_tone"
		],
		"filename": "270d-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_light_skin_tone"
		],
		"filename": "270d-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_skin_tone"
		],
		"filename": "270d-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_medium_dark_skin_tone"
		],
		"filename": "270d-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"writing_hand_dark_skin_tone"
		],
		"filename": "270d-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_light_skin_tone"
		],
		"filename": "1f485-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_light_skin_tone"
		],
		"filename": "1f485-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_skin_tone"
		],
		"filename": "1f485-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_medium_dark_skin_tone"
		],
		"filename": "1f485-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nail_care_dark_skin_tone"
		],
		"filename": "1f485-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_light_skin_tone"
		],
		"filename": "1f933-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_light_skin_tone"
		],
		"filename": "1f933-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_skin_tone"
		],
		"filename": "1f933-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_medium_dark_skin_tone"
		],
		"filename": "1f933-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"selfie_dark_skin_tone"
		],
		"filename": "1f933-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_light_skin_tone"
		],
		"filename": "1f4aa-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_light_skin_tone"
		],
		"filename": "1f4aa-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_skin_tone"
		],
		"filename": "1f4aa-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_medium_dark_skin_tone"
		],
		"filename": "1f4aa-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"muscle_dark_skin_tone"
		],
		"filename": "1f4aa-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_light_skin_tone"
		],
		"filename": "1f9b5-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_light_skin_tone"
		],
		"filename": "1f9b5-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_skin_tone"
		],
		"filename": "1f9b5-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_medium_dark_skin_tone"
		],
		"filename": "1f9b5-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"leg_dark_skin_tone"
		],
		"filename": "1f9b5-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_light_skin_tone"
		],
		"filename": "1f9b6-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_light_skin_tone"
		],
		"filename": "1f9b6-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_skin_tone"
		],
		"filename": "1f9b6-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_medium_dark_skin_tone"
		],
		"filename": "1f9b6-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"foot_dark_skin_tone"
		],
		"filename": "1f9b6-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_light_skin_tone"
		],
		"filename": "1f442-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_light_skin_tone"
		],
		"filename": "1f442-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_skin_tone"
		],
		"filename": "1f442-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_medium_dark_skin_tone"
		],
		"filename": "1f442-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_dark_skin_tone"
		],
		"filename": "1f442-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_light_skin_tone"
		],
		"filename": "1f9bb-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_light_skin_tone"
		],
		"filename": "1f9bb-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_skin_tone"
		],
		"filename": "1f9bb-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_medium_dark_skin_tone"
		],
		"filename": "1f9bb-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"ear_with_hearing_aid_dark_skin_tone"
		],
		"filename": "1f9bb-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"nose_light_skin_tone"
		],
		"filename": "1f443-1f3fb",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_light_skin_tone"
		],
		"filename": "1f443-1f3fc",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_skin_tone"
		],
		"filename": "1f443-1f3fd",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_medium_dark_skin_tone"
		],
		"filename": "1f443-1f3fe",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"nose_dark_skin_tone"
		],
		"filename": "1f443-1f3ff",
		"category": "skintone",
		"batch": "4"
	},
	{
		"aliases": [
			"baby_light_skin_tone"
		],
		"filename": "1f476-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_light_skin_tone"
		],
		"filename": "1f476-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_skin_tone"
		],
		"filename": "1f476-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_medium_dark_skin_tone"
		],
		"filename": "1f476-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"baby_dark_skin_tone"
		],
		"filename": "1f476-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_light_skin_tone"
		],
		"filename": "1f9d2-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_light_skin_tone"
		],
		"filename": "1f9d2-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_skin_tone"
		],
		"filename": "1f9d2-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_medium_dark_skin_tone"
		],
		"filename": "1f9d2-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"child_dark_skin_tone"
		],
		"filename": "1f9d2-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_light_skin_tone"
		],
		"filename": "1f466-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_light_skin_tone"
		],
		"filename": "1f466-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_skin_tone"
		],
		"filename": "1f466-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_medium_dark_skin_tone"
		],
		"filename": "1f466-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"boy_dark_skin_tone"
		],
		"filename": "1f466-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_light_skin_tone"
		],
		"filename": "1f467-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_light_skin_tone"
		],
		"filename": "1f467-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_skin_tone"
		],
		"filename": "1f467-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_medium_dark_skin_tone"
		],
		"filename": "1f467-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"girl_dark_skin_tone"
		],
		"filename": "1f467-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"adult_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_light_skin_tone"
		],
		"filename": "1f471-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_skin_tone"
		],
		"filename": "1f471-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"person_dark_skin_tone"
		],
		"filename": "1f471-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"blond_haired_person_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_light_skin_tone"
		],
		"filename": "1f468-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_light_skin_tone"
		],
		"filename": "1f9d4-1f3fb",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_light_skin_tone"
		],
		"filename": "1f9d4-1f3fc",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_skin_tone"
		],
		"filename": "1f9d4-1f3fd",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_medium_dark_skin_tone"
		],
		"filename": "1f9d4-1f3fe",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"bearded_person_dark_skin_tone"
		],
		"filename": "1f9d4-1f3ff",
		"category": "skintone",
		"batch": "5"
	},
	{
		"aliases": [
			"red_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"bald_man_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"red_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_red_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b0",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"curly_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"person_curly_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b1",
		"category": "skintone",
		"batch": "6"
	},
	{
		"aliases": [
			"white_haired_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"white_haired_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_white_hair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b3",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"bald_woman_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"person_bald_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9b2",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_woman_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_light_skin_tone"
		],
		"filename": "1f471-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_light_skin_tone"
		],
		"filename": "1f471-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_skin_tone"
		],
		"filename": "1f471-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_medium_dark_skin_tone"
		],
		"filename": "1f471-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"blond_haired_man_dark_skin_tone"
		],
		"filename": "1f471-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_light_skin_tone"
		],
		"filename": "1f9d3-1f3fb",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_light_skin_tone"
		],
		"filename": "1f9d3-1f3fc",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_skin_tone"
		],
		"filename": "1f9d3-1f3fd",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_medium_dark_skin_tone"
		],
		"filename": "1f9d3-1f3fe",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_adult_dark_skin_tone"
		],
		"filename": "1f9d3-1f3ff",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_light_skin_tone"
		],
		"filename": "1f474-1f3fb",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_light_skin_tone"
		],
		"filename": "1f474-1f3fc",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_skin_tone"
		],
		"filename": "1f474-1f3fd",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_medium_dark_skin_tone"
		],
		"filename": "1f474-1f3fe",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_man_dark_skin_tone"
		],
		"filename": "1f474-1f3ff",
		"category": "skintone",
		"batch": "7"
	},
	{
		"aliases": [
			"older_woman_light_skin_tone"
		],
		"filename": "1f475-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_light_skin_tone"
		],
		"filename": "1f475-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_skin_tone"
		],
		"filename": "1f475-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_medium_dark_skin_tone"
		],
		"filename": "1f475-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"older_woman_dark_skin_tone"
		],
		"filename": "1f475-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_light_skin_tone"
		],
		"filename": "1f64d-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_person_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_light_skin_tone"
		],
		"filename": "1f64d-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_man_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_light_skin_tone"
		],
		"filename": "1f64d-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_light_skin_tone"
		],
		"filename": "1f64d-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_skin_tone"
		],
		"filename": "1f64d-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_medium_dark_skin_tone"
		],
		"filename": "1f64d-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"frowning_woman_dark_skin_tone"
		],
		"filename": "1f64d-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_light_skin_tone"
		],
		"filename": "1f64e-1f3fb",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_face_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_light_skin_tone"
		],
		"filename": "1f64e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_man_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "8"
	},
	{
		"aliases": [
			"pouting_woman_light_skin_tone"
		],
		"filename": "1f64e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_light_skin_tone"
		],
		"filename": "1f64e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_skin_tone"
		],
		"filename": "1f64e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_medium_dark_skin_tone"
		],
		"filename": "1f64e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"pouting_woman_dark_skin_tone"
		],
		"filename": "1f64e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_light_skin_tone"
		],
		"filename": "1f645-1f3fb",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_skin_tone"
		],
		"filename": "1f645-1f3fd",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_dark_skin_tone"
		],
		"filename": "1f645-1f3ff",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_light_skin_tone"
		],
		"filename": "1f645-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_skin_tone"
		],
		"filename": "1f645-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_man_dark_skin_tone"
		],
		"filename": "1f645-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_light_skin_tone"
		],
		"filename": "1f645-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_light_skin_tone"
		],
		"filename": "1f645-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_skin_tone"
		],
		"filename": "1f645-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_medium_dark_skin_tone"
		],
		"filename": "1f645-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"no_good_woman_dark_skin_tone"
		],
		"filename": "1f645-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_light_skin_tone"
		],
		"filename": "1f646-1f3fb",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_skin_tone"
		],
		"filename": "1f646-1f3fd",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_person_dark_skin_tone"
		],
		"filename": "1f646-1f3ff",
		"category": "skintone",
		"batch": "9"
	},
	{
		"aliases": [
			"ok_man_light_skin_tone"
		],
		"filename": "1f646-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_skin_tone"
		],
		"filename": "1f646-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_man_dark_skin_tone"
		],
		"filename": "1f646-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_light_skin_tone"
		],
		"filename": "1f646-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_light_skin_tone"
		],
		"filename": "1f646-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_skin_tone"
		],
		"filename": "1f646-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_medium_dark_skin_tone"
		],
		"filename": "1f646-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"ok_woman_dark_skin_tone"
		],
		"filename": "1f646-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_light_skin_tone"
		],
		"filename": "1f481-1f3fb",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_skin_tone"
		],
		"filename": "1f481-1f3fd",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_person_dark_skin_tone"
		],
		"filename": "1f481-1f3ff",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_light_skin_tone"
		],
		"filename": "1f481-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_skin_tone"
		],
		"filename": "1f481-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_man_dark_skin_tone"
		],
		"filename": "1f481-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_light_skin_tone"
		],
		"filename": "1f481-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_light_skin_tone"
		],
		"filename": "1f481-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_skin_tone"
		],
		"filename": "1f481-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_medium_dark_skin_tone"
		],
		"filename": "1f481-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"tipping_hand_woman_dark_skin_tone"
		],
		"filename": "1f481-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_light_skin_tone"
		],
		"filename": "1f64b-1f3fb",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff",
		"category": "skintone",
		"batch": "10"
	},
	{
		"aliases": [
			"raising_hand_man_light_skin_tone"
		],
		"filename": "1f64b-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_man_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_light_skin_tone"
		],
		"filename": "1f64b-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_light_skin_tone"
		],
		"filename": "1f64b-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_skin_tone"
		],
		"filename": "1f64b-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_medium_dark_skin_tone"
		],
		"filename": "1f64b-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"raising_hand_woman_dark_skin_tone"
		],
		"filename": "1f64b-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"deaf_person_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_person_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_man_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_light_skin_tone"
		],
		"filename": "1f9cf-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_light_skin_tone"
		],
		"filename": "1f9cf-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_skin_tone"
		],
		"filename": "1f9cf-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_medium_dark_skin_tone"
		],
		"filename": "1f9cf-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"deaf_woman_dark_skin_tone"
		],
		"filename": "1f9cf-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "1"
	},
	{
		"aliases": [
			"bow_light_skin_tone"
		],
		"filename": "1f647-1f3fb",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_skin_tone"
		],
		"filename": "1f647-1f3fd",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bow_dark_skin_tone"
		],
		"filename": "1f647-1f3ff",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_light_skin_tone"
		],
		"filename": "1f647-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_skin_tone"
		],
		"filename": "1f647-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_man_dark_skin_tone"
		],
		"filename": "1f647-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_light_skin_tone"
		],
		"filename": "1f647-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_light_skin_tone"
		],
		"filename": "1f647-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_skin_tone"
		],
		"filename": "1f647-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_medium_dark_skin_tone"
		],
		"filename": "1f647-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"bowing_woman_dark_skin_tone"
		],
		"filename": "1f647-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "11"
	},
	{
		"aliases": [
			"facepalm_light_skin_tone"
		],
		"filename": "1f926-1f3fb",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_skin_tone"
		],
		"filename": "1f926-1f3fd",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"facepalm_dark_skin_tone"
		],
		"filename": "1f926-1f3ff",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_light_skin_tone"
		],
		"filename": "1f926-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_skin_tone"
		],
		"filename": "1f926-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_facepalming_dark_skin_tone"
		],
		"filename": "1f926-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_light_skin_tone"
		],
		"filename": "1f926-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_light_skin_tone"
		],
		"filename": "1f926-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_skin_tone"
		],
		"filename": "1f926-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_medium_dark_skin_tone"
		],
		"filename": "1f926-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_facepalming_dark_skin_tone"
		],
		"filename": "1f926-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_light_skin_tone"
		],
		"filename": "1f937-1f3fb",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_skin_tone"
		],
		"filename": "1f937-1f3fd",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"shrug_dark_skin_tone"
		],
		"filename": "1f937-1f3ff",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_light_skin_tone"
		],
		"filename": "1f937-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_skin_tone"
		],
		"filename": "1f937-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"man_shrugging_dark_skin_tone"
		],
		"filename": "1f937-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "12"
	},
	{
		"aliases": [
			"woman_shrugging_light_skin_tone"
		],
		"filename": "1f937-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_light_skin_tone"
		],
		"filename": "1f937-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_skin_tone"
		],
		"filename": "1f937-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_medium_dark_skin_tone"
		],
		"filename": "1f937-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_shrugging_dark_skin_tone"
		],
		"filename": "1f937-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"health_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_health_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_health_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2695-fe0f",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"student_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_student_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_student_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f393",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"teacher_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"man_teacher_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "13"
	},
	{
		"aliases": [
			"woman_teacher_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_teacher_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3eb",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"judge_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_judge_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_judge_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2696-fe0f",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"farmer_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_farmer_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_farmer_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f33e",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"cook_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"man_cook_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "14"
	},
	{
		"aliases": [
			"woman_cook_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_cook_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f373",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"mechanic_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_mechanic_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_mechanic_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f527",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"factory_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_factory_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_factory_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3ed",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"office_worker_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"man_office_worker_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "15"
	},
	{
		"aliases": [
			"woman_office_worker_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_office_worker_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f4bc",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"scientist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_scientist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_scientist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f52c",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"technologist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_technologist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_technologist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f4bb",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"singer_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"man_singer_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "16"
	},
	{
		"aliases": [
			"woman_singer_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_singer_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3a4",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"artist_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_artist_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_artist_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f3a8",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"pilot_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_pilot_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_pilot_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-2708-fe0f",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"astronaut_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"man_astronaut_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "17"
	},
	{
		"aliases": [
			"woman_astronaut_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_astronaut_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f680",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"firefighter_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"man_firefighter_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"woman_firefighter_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f692",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_light_skin_tone"
		],
		"filename": "1f46e-1f3fb",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"police_officer_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_light_skin_tone"
		],
		"filename": "1f46e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policeman_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_light_skin_tone"
		],
		"filename": "1f46e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_light_skin_tone"
		],
		"filename": "1f46e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_skin_tone"
		],
		"filename": "1f46e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_medium_dark_skin_tone"
		],
		"filename": "1f46e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"policewoman_dark_skin_tone"
		],
		"filename": "1f46e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "18"
	},
	{
		"aliases": [
			"detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"male_detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_light_skin_tone"
		],
		"filename": "1f575-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_light_skin_tone"
		],
		"filename": "1f575-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_skin_tone"
		],
		"filename": "1f575-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_medium_dark_skin_tone"
		],
		"filename": "1f575-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"female_detective_dark_skin_tone"
		],
		"filename": "1f575-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_light_skin_tone"
		],
		"filename": "1f482-1f3fb",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_skin_tone"
		],
		"filename": "1f482-1f3fd",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guard_dark_skin_tone"
		],
		"filename": "1f482-1f3ff",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_light_skin_tone"
		],
		"filename": "1f482-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_skin_tone"
		],
		"filename": "1f482-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardsman_dark_skin_tone"
		],
		"filename": "1f482-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "19"
	},
	{
		"aliases": [
			"guardswoman_light_skin_tone"
		],
		"filename": "1f482-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_light_skin_tone"
		],
		"filename": "1f482-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_skin_tone"
		],
		"filename": "1f482-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_medium_dark_skin_tone"
		],
		"filename": "1f482-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"guardswoman_dark_skin_tone"
		],
		"filename": "1f482-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_light_skin_tone"
		],
		"filename": "1f477-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_skin_tone"
		],
		"filename": "1f477-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_dark_skin_tone"
		],
		"filename": "1f477-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_light_skin_tone"
		],
		"filename": "1f477-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_skin_tone"
		],
		"filename": "1f477-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_man_dark_skin_tone"
		],
		"filename": "1f477-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_light_skin_tone"
		],
		"filename": "1f477-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_light_skin_tone"
		],
		"filename": "1f477-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_skin_tone"
		],
		"filename": "1f477-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_medium_dark_skin_tone"
		],
		"filename": "1f477-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"construction_worker_woman_dark_skin_tone"
		],
		"filename": "1f477-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_light_skin_tone"
		],
		"filename": "1f934-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_light_skin_tone"
		],
		"filename": "1f934-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_skin_tone"
		],
		"filename": "1f934-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_medium_dark_skin_tone"
		],
		"filename": "1f934-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"prince_dark_skin_tone"
		],
		"filename": "1f934-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_light_skin_tone"
		],
		"filename": "1f478-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_light_skin_tone"
		],
		"filename": "1f478-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_skin_tone"
		],
		"filename": "1f478-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_medium_dark_skin_tone"
		],
		"filename": "1f478-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"princess_dark_skin_tone"
		],
		"filename": "1f478-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"person_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff",
		"category": "skintone",
		"batch": "20"
	},
	{
		"aliases": [
			"man_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_light_skin_tone"
		],
		"filename": "1f473-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_light_skin_tone"
		],
		"filename": "1f473-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_skin_tone"
		],
		"filename": "1f473-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_medium_dark_skin_tone"
		],
		"filename": "1f473-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_turban_dark_skin_tone"
		],
		"filename": "1f473-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_light_skin_tone"
		],
		"filename": "1f472-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_light_skin_tone"
		],
		"filename": "1f472-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_skin_tone"
		],
		"filename": "1f472-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_medium_dark_skin_tone"
		],
		"filename": "1f472-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_with_gua_pi_mao_dark_skin_tone"
		],
		"filename": "1f472-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_light_skin_tone"
		],
		"filename": "1f9d5-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_light_skin_tone"
		],
		"filename": "1f9d5-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_skin_tone"
		],
		"filename": "1f9d5-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_medium_dark_skin_tone"
		],
		"filename": "1f9d5-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"woman_with_headscarf_dark_skin_tone"
		],
		"filename": "1f9d5-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_light_skin_tone"
		],
		"filename": "1f935-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_light_skin_tone"
		],
		"filename": "1f935-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_skin_tone"
		],
		"filename": "1f935-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_medium_dark_skin_tone"
		],
		"filename": "1f935-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"man_in_tuxedo_dark_skin_tone"
		],
		"filename": "1f935-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_light_skin_tone"
		],
		"filename": "1f470-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_light_skin_tone"
		],
		"filename": "1f470-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_skin_tone"
		],
		"filename": "1f470-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_medium_dark_skin_tone"
		],
		"filename": "1f470-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"bride_with_veil_dark_skin_tone"
		],
		"filename": "1f470-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_light_skin_tone"
		],
		"filename": "1f930-1f3fb",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_light_skin_tone"
		],
		"filename": "1f930-1f3fc",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_skin_tone"
		],
		"filename": "1f930-1f3fd",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_medium_dark_skin_tone"
		],
		"filename": "1f930-1f3fe",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"pregnant_woman_dark_skin_tone"
		],
		"filename": "1f930-1f3ff",
		"category": "skintone",
		"batch": "21"
	},
	{
		"aliases": [
			"breast_feeding_light_skin_tone"
		],
		"filename": "1f931-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_light_skin_tone"
		],
		"filename": "1f931-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_skin_tone"
		],
		"filename": "1f931-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_medium_dark_skin_tone"
		],
		"filename": "1f931-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"breast_feeding_dark_skin_tone"
		],
		"filename": "1f931-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_light_skin_tone"
		],
		"filename": "1f47c-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_light_skin_tone"
		],
		"filename": "1f47c-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_skin_tone"
		],
		"filename": "1f47c-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_medium_dark_skin_tone"
		],
		"filename": "1f47c-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"angel_dark_skin_tone"
		],
		"filename": "1f47c-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_light_skin_tone"
		],
		"filename": "1f385-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_light_skin_tone"
		],
		"filename": "1f385-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_skin_tone"
		],
		"filename": "1f385-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_medium_dark_skin_tone"
		],
		"filename": "1f385-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"santa_dark_skin_tone"
		],
		"filename": "1f385-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_light_skin_tone"
		],
		"filename": "1f936-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_light_skin_tone"
		],
		"filename": "1f936-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_skin_tone"
		],
		"filename": "1f936-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_medium_dark_skin_tone"
		],
		"filename": "1f936-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"mrs_claus_dark_skin_tone"
		],
		"filename": "1f936-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_man_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_light_skin_tone"
		],
		"filename": "1f9b8-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_light_skin_tone"
		],
		"filename": "1f9b8-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_skin_tone"
		],
		"filename": "1f9b8-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_medium_dark_skin_tone"
		],
		"filename": "1f9b8-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"superhero_woman_dark_skin_tone"
		],
		"filename": "1f9b8-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "22"
	},
	{
		"aliases": [
			"supervillain_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_man_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_light_skin_tone"
		],
		"filename": "1f9b9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_light_skin_tone"
		],
		"filename": "1f9b9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_skin_tone"
		],
		"filename": "1f9b9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_medium_dark_skin_tone"
		],
		"filename": "1f9b9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"supervillain_woman_dark_skin_tone"
		],
		"filename": "1f9b9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_man_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "23"
	},
	{
		"aliases": [
			"mage_woman_light_skin_tone"
		],
		"filename": "1f9d9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_light_skin_tone"
		],
		"filename": "1f9d9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_skin_tone"
		],
		"filename": "1f9d9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"mage_woman_dark_skin_tone"
		],
		"filename": "1f9d9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_light_skin_tone"
		],
		"filename": "1f9da-1f3fb",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_light_skin_tone"
		],
		"filename": "1f9da-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_man_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_light_skin_tone"
		],
		"filename": "1f9da-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_light_skin_tone"
		],
		"filename": "1f9da-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_skin_tone"
		],
		"filename": "1f9da-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_medium_dark_skin_tone"
		],
		"filename": "1f9da-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"fairy_woman_dark_skin_tone"
		],
		"filename": "1f9da-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_light_skin_tone"
		],
		"filename": "1f9db-1f3fb",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_light_skin_tone"
		],
		"filename": "1f9db-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_man_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "24"
	},
	{
		"aliases": [
			"vampire_woman_light_skin_tone"
		],
		"filename": "1f9db-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_light_skin_tone"
		],
		"filename": "1f9db-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_skin_tone"
		],
		"filename": "1f9db-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_medium_dark_skin_tone"
		],
		"filename": "1f9db-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"vampire_woman_dark_skin_tone"
		],
		"filename": "1f9db-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merperson_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"merman_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_light_skin_tone"
		],
		"filename": "1f9dc-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_light_skin_tone"
		],
		"filename": "1f9dc-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_skin_tone"
		],
		"filename": "1f9dc-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_medium_dark_skin_tone"
		],
		"filename": "1f9dc-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"mermaid_dark_skin_tone"
		],
		"filename": "1f9dc-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff",
		"category": "skintone",
		"batch": "25"
	},
	{
		"aliases": [
			"elf_man_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_man_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_light_skin_tone"
		],
		"filename": "1f9dd-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_light_skin_tone"
		],
		"filename": "1f9dd-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_skin_tone"
		],
		"filename": "1f9dd-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_medium_dark_skin_tone"
		],
		"filename": "1f9dd-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"elf_woman_dark_skin_tone"
		],
		"filename": "1f9dd-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_light_skin_tone"
		],
		"filename": "1f486-1f3fb",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_skin_tone"
		],
		"filename": "1f486-1f3fd",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_dark_skin_tone"
		],
		"filename": "1f486-1f3ff",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_light_skin_tone"
		],
		"filename": "1f486-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_skin_tone"
		],
		"filename": "1f486-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_man_dark_skin_tone"
		],
		"filename": "1f486-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_light_skin_tone"
		],
		"filename": "1f486-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_light_skin_tone"
		],
		"filename": "1f486-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_skin_tone"
		],
		"filename": "1f486-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_medium_dark_skin_tone"
		],
		"filename": "1f486-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"massage_woman_dark_skin_tone"
		],
		"filename": "1f486-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_light_skin_tone"
		],
		"filename": "1f487-1f3fb",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_skin_tone"
		],
		"filename": "1f487-1f3fd",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_dark_skin_tone"
		],
		"filename": "1f487-1f3ff",
		"category": "skintone",
		"batch": "26"
	},
	{
		"aliases": [
			"haircut_man_light_skin_tone"
		],
		"filename": "1f487-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_skin_tone"
		],
		"filename": "1f487-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_man_dark_skin_tone"
		],
		"filename": "1f487-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_light_skin_tone"
		],
		"filename": "1f487-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_light_skin_tone"
		],
		"filename": "1f487-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_skin_tone"
		],
		"filename": "1f487-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_medium_dark_skin_tone"
		],
		"filename": "1f487-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"haircut_woman_dark_skin_tone"
		],
		"filename": "1f487-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_dark_skin_tone"
		],
		"filename": "1f6b6-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_man_dark_skin_tone"
		],
		"filename": "1f6b6-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_light_skin_tone"
		],
		"filename": "1f6b6-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b6-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_skin_tone"
		],
		"filename": "1f6b6-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"walking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b6-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_man_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_light_skin_tone"
		],
		"filename": "1f9cd-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_light_skin_tone"
		],
		"filename": "1f9cd-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_skin_tone"
		],
		"filename": "1f9cd-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_medium_dark_skin_tone"
		],
		"filename": "1f9cd-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"standing_woman_dark_skin_tone"
		],
		"filename": "1f9cd-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_man_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_light_skin_tone"
		],
		"filename": "1f9ce-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_light_skin_tone"
		],
		"filename": "1f9ce-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_skin_tone"
		],
		"filename": "1f9ce-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_medium_dark_skin_tone"
		],
		"filename": "1f9ce-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"kneeling_woman_dark_skin_tone"
		],
		"filename": "1f9ce-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "27"
	},
	{
		"aliases": [
			"person_with_probing_cane_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_with_probing_cane_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9af",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_motorized_wheelchair_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9bc",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"person_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"man_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"woman_in_manual_wheelchair_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f9bd",
		"category": "skintone",
		"batch": "28"
	},
	{
		"aliases": [
			"runner_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"runner_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_man_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_light_skin_tone"
		],
		"filename": "1f3c3-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_light_skin_tone"
		],
		"filename": "1f3c3-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_skin_tone"
		],
		"filename": "1f3c3-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_medium_dark_skin_tone"
		],
		"filename": "1f3c3-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"running_woman_dark_skin_tone"
		],
		"filename": "1f3c3-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_light_skin_tone"
		],
		"filename": "1f483-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_light_skin_tone"
		],
		"filename": "1f483-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_skin_tone"
		],
		"filename": "1f483-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_medium_dark_skin_tone"
		],
		"filename": "1f483-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"woman_dancing_dark_skin_tone"
		],
		"filename": "1f483-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_light_skin_tone"
		],
		"filename": "1f57a-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_light_skin_tone"
		],
		"filename": "1f57a-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_skin_tone"
		],
		"filename": "1f57a-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_medium_dark_skin_tone"
		],
		"filename": "1f57a-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"man_dancing_dark_skin_tone"
		],
		"filename": "1f57a-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_light_skin_tone"
		],
		"filename": "1f574-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_light_skin_tone"
		],
		"filename": "1f574-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_skin_tone"
		],
		"filename": "1f574-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_medium_dark_skin_tone"
		],
		"filename": "1f574-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"business_suit_levitating_dark_skin_tone"
		],
		"filename": "1f574-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_person_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff",
		"category": "skintone",
		"batch": "29"
	},
	{
		"aliases": [
			"sauna_man_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_man_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_light_skin_tone"
		],
		"filename": "1f9d6-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_light_skin_tone"
		],
		"filename": "1f9d6-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_skin_tone"
		],
		"filename": "1f9d6-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d6-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"sauna_woman_dark_skin_tone"
		],
		"filename": "1f9d6-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_man_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_light_skin_tone"
		],
		"filename": "1f9d7-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_light_skin_tone"
		],
		"filename": "1f9d7-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_skin_tone"
		],
		"filename": "1f9d7-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d7-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"climbing_woman_dark_skin_tone"
		],
		"filename": "1f9d7-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "30"
	},
	{
		"aliases": [
			"horse_racing_light_skin_tone"
		],
		"filename": "1f3c7-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_light_skin_tone"
		],
		"filename": "1f3c7-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_skin_tone"
		],
		"filename": "1f3c7-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_medium_dark_skin_tone"
		],
		"filename": "1f3c7-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"horse_racing_dark_skin_tone"
		],
		"filename": "1f3c7-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_man_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_light_skin_tone"
		],
		"filename": "1f3cc-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_light_skin_tone"
		],
		"filename": "1f3cc-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_skin_tone"
		],
		"filename": "1f3cc-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_medium_dark_skin_tone"
		],
		"filename": "1f3cc-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"golfing_woman_dark_skin_tone"
		],
		"filename": "1f3cc-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfer_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_man_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "31"
	},
	{
		"aliases": [
			"surfing_woman_light_skin_tone"
		],
		"filename": "1f3c4-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_light_skin_tone"
		],
		"filename": "1f3c4-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_skin_tone"
		],
		"filename": "1f3c4-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_medium_dark_skin_tone"
		],
		"filename": "1f3c4-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"surfing_woman_dark_skin_tone"
		],
		"filename": "1f3c4-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowboat_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_man_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_light_skin_tone"
		],
		"filename": "1f6a3-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_light_skin_tone"
		],
		"filename": "1f6a3-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_skin_tone"
		],
		"filename": "1f6a3-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_medium_dark_skin_tone"
		],
		"filename": "1f6a3-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"rowing_woman_dark_skin_tone"
		],
		"filename": "1f6a3-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimmer_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff",
		"category": "skintone",
		"batch": "32"
	},
	{
		"aliases": [
			"swimming_man_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_man_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_light_skin_tone"
		],
		"filename": "1f3ca-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_light_skin_tone"
		],
		"filename": "1f3ca-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_skin_tone"
		],
		"filename": "1f3ca-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_medium_dark_skin_tone"
		],
		"filename": "1f3ca-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"swimming_woman_dark_skin_tone"
		],
		"filename": "1f3ca-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_light_skin_tone"
		],
		"filename": "26f9-1f3fb",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_skin_tone"
		],
		"filename": "26f9-1f3fd",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_person_dark_skin_tone"
		],
		"filename": "26f9-1f3ff",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_light_skin_tone"
		],
		"filename": "26f9-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_skin_tone"
		],
		"filename": "26f9-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_man_dark_skin_tone"
		],
		"filename": "26f9-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_light_skin_tone"
		],
		"filename": "26f9-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_light_skin_tone"
		],
		"filename": "26f9-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_skin_tone"
		],
		"filename": "26f9-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_medium_dark_skin_tone"
		],
		"filename": "26f9-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"bouncing_ball_woman_dark_skin_tone"
		],
		"filename": "26f9-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff",
		"category": "skintone",
		"batch": "33"
	},
	{
		"aliases": [
			"weight_lifting_man_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_man_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_light_skin_tone"
		],
		"filename": "1f3cb-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_light_skin_tone"
		],
		"filename": "1f3cb-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_skin_tone"
		],
		"filename": "1f3cb-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_medium_dark_skin_tone"
		],
		"filename": "1f3cb-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"weight_lifting_woman_dark_skin_tone"
		],
		"filename": "1f3cb-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"bicyclist_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_man_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_light_skin_tone"
		],
		"filename": "1f6b4-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b4-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_skin_tone"
		],
		"filename": "1f6b4-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b4-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"biking_woman_dark_skin_tone"
		],
		"filename": "1f6b4-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "34"
	},
	{
		"aliases": [
			"mountain_bicyclist_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_bicyclist_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_man_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_light_skin_tone"
		],
		"filename": "1f6b5-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_light_skin_tone"
		],
		"filename": "1f6b5-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_skin_tone"
		],
		"filename": "1f6b5-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_medium_dark_skin_tone"
		],
		"filename": "1f6b5-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"mountain_biking_woman_dark_skin_tone"
		],
		"filename": "1f6b5-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"man_cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "35"
	},
	{
		"aliases": [
			"woman_cartwheeling_light_skin_tone"
		],
		"filename": "1f938-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_light_skin_tone"
		],
		"filename": "1f938-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_skin_tone"
		],
		"filename": "1f938-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_medium_dark_skin_tone"
		],
		"filename": "1f938-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_cartwheeling_dark_skin_tone"
		],
		"filename": "1f938-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_light_skin_tone"
		],
		"filename": "1f93d-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_light_skin_tone"
		],
		"filename": "1f93d-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_skin_tone"
		],
		"filename": "1f93d-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_medium_dark_skin_tone"
		],
		"filename": "1f93d-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_water_polo_dark_skin_tone"
		],
		"filename": "1f93d-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_light_skin_tone"
		],
		"filename": "1f93e-1f3fb",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"handball_person_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_light_skin_tone"
		],
		"filename": "1f93e-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"man_playing_handball_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "36"
	},
	{
		"aliases": [
			"woman_playing_handball_light_skin_tone"
		],
		"filename": "1f93e-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_light_skin_tone"
		],
		"filename": "1f93e-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_skin_tone"
		],
		"filename": "1f93e-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_medium_dark_skin_tone"
		],
		"filename": "1f93e-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_playing_handball_dark_skin_tone"
		],
		"filename": "1f93e-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_light_skin_tone"
		],
		"filename": "1f939-1f3fb",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_skin_tone"
		],
		"filename": "1f939-1f3fd",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"juggling_person_dark_skin_tone"
		],
		"filename": "1f939-1f3ff",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_light_skin_tone"
		],
		"filename": "1f939-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_skin_tone"
		],
		"filename": "1f939-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"man_juggling_dark_skin_tone"
		],
		"filename": "1f939-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_light_skin_tone"
		],
		"filename": "1f939-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_light_skin_tone"
		],
		"filename": "1f939-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_skin_tone"
		],
		"filename": "1f939-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_medium_dark_skin_tone"
		],
		"filename": "1f939-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"woman_juggling_dark_skin_tone"
		],
		"filename": "1f939-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff",
		"category": "skintone",
		"batch": "37"
	},
	{
		"aliases": [
			"lotus_position_man_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_man_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff-200d-2642-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_light_skin_tone"
		],
		"filename": "1f9d8-1f3fb-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_light_skin_tone"
		],
		"filename": "1f9d8-1f3fc-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_skin_tone"
		],
		"filename": "1f9d8-1f3fd-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_medium_dark_skin_tone"
		],
		"filename": "1f9d8-1f3fe-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"lotus_position_woman_dark_skin_tone"
		],
		"filename": "1f9d8-1f3ff-200d-2640-fe0f",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_light_skin_tone"
		],
		"filename": "1f6c0-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_light_skin_tone"
		],
		"filename": "1f6c0-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_skin_tone"
		],
		"filename": "1f6c0-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_medium_dark_skin_tone"
		],
		"filename": "1f6c0-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"bath_dark_skin_tone"
		],
		"filename": "1f6c0-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"people_holding_hands_dark_skin_tone"
		],
		"filename": "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone"
		],
		"filename": "1f46d-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46d-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone"
		],
		"filename": "1f46d-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46d-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"women_holding_hands_dark_skin_tone"
		],
		"filename": "1f46d-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone"
		],
		"filename": "1f46b-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46b-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone"
		],
		"filename": "1f46b-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46b-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"woman_and_man_holding_hands_dark_skin_tone"
		],
		"filename": "1f46b-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone"
		],
		"filename": "1f46c-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone"
		],
		"filename": "1f46c-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_light_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone"
		],
		"filename": "1f46c-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone"
		],
		"filename": "1f46c-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_medium_dark_skin_tone_dark_skin_tone"
		],
		"filename": "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_light_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_light_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone_medium_dark_skin_tone"
		],
		"filename": "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe",
		"category": "skintone",
		"batch": "38"
	},
	{
		"aliases": [
			"men_holding_hands_dark_skin_tone"
		],
		"filename": "1f46c-1f3ff",
		"category": "skintone",
		"batch": "38"
	}
];


//////////////////
// WEBPACK FOOTER
// ./utils/emoji.json
// module id = 1101
// module chunks = 76